// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { OutletContextType, schooYearType } from "../../types/GlobalType";
import { LightModeOutlined } from "@mui/icons-material";
import moment from "moment";
import { capitalizeFirstLetter } from "../../_services/utils";
import { StudentType } from "../../_api/controllers/student.controller";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  PonctualiteType,
  studentAttendanceController,
} from "../../_api/controllers/attendance.controller.ts";
import toast from "react-hot-toast";
import {
  classeController,
  montantController,
  motifPaiementController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { paymentController } from "../../_api/controllers/payment.controller.ts";
import { useAuth } from "../../_api/auth.js";
import HasRole from "../../component/_elements/HasRole.tsx";
import { useLogout } from "../../_api/useAuth.js";
import {
  messageControler,
  MessageType,
} from "../../_api/controllers/message.controller.ts";
import MyLoader from "../../component/loader/MyLoader.tsx";
import { login as loginAPI } from "../../_api/auth.js";

//skeleton forn student profile
const StudentProfileSkeleton: React.FC<{ isDarkMode: boolean }> = ({
  isDarkMode,
}) => (
  <div className="animate-pulse">
    {/* Header */}
    <div
      className={`ml-20 md:ml-0 px-6 py-6 border-b mt-16 ${
        isDarkMode ? "border-gray-700" : "border-gray-200"
      }`}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          {/* Avatar */}
          <div
            className={`w-16 h-16 rounded-full ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          ></div>

          <div className="ml-4 space-y-2">
            <div
              className={`h-5 w-48 rounded ${
                isDarkMode ? "bg-gray-700" : "bg-gray-300"
              }`}
            ></div>
            <div className="flex gap-2">
              <div
                className={`h-4 w-16 rounded-full ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
              <div
                className={`h-4 w-24 rounded-full ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
            </div>
          </div>
        </div>

        {/* Action Button */}
        {/* <div
          className={`h-10 w-32 rounded-md ${
            isDarkMode ? "bg-gray-700" : "bg-gray-300"
          }`}
        ></div> */}
      </div>
    </div>

    {/* Tabs */}
    <div
      className={`ml-20 md:ml-0 px-6 border-b ${
        isDarkMode ? "border-gray-700" : "border-gray-200"
      }`}
    >
      <div className="flex gap-4 py-3">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className={`h-4 w-32 rounded ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
    </div>

    {/* Content */}
    <div className="ml-20 md:ml-0 p-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Main info */}
      <div
        className={`lg:col-span-2 rounded-lg border ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}
      >
        <div
          className={`h-10 ${isDarkMode ? "bg-gray-800" : "bg-gray-100"}`}
        ></div>
        <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div
                className={`h-3 w-24 rounded ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
              <div
                className={`h-4 w-full rounded ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
            </div>
          ))}
        </div>
      </div>

      {/* Medical info */}
      <div
        className={`rounded-lg border ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}
      >
        <div
          className={`h-10 ${isDarkMode ? "bg-gray-800" : "bg-gray-100"}`}
        ></div>
        <div className="p-4 space-y-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div
                className={`h-3 w-28 rounded ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
              <div
                className={`h-4 w-full rounded ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-300"
                }`}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const SingleStudent: React.FC = () => {
  // fetch students attendance
  const dataStudent = useLocation().state as StudentType;
  // console.log(dataStudent);

  // État pour les onglets et le modal
  const [activeTab, setActiveTab] = useState("informations");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isAbsenceModalOpen, setIsAbsenceModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedStatusAttendance, setSelectedStatusAttendance] =
    useState<any>("Tous les statuts");
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
  };

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const [showCancelModal, setShowCancelModal] = useState(false);
  type PaymentAction = "create" | "cancel";
  const [pendingPaiementAction, setPendingPaiementAction] =
    useState<PaymentAction | null>(null);

  // fetch Active schoolYear
  const { isLoading: activeSchoolYearLoading } = useQuery({
    queryKey: ["ActiveSchoolYear"],
    queryFn: schoolYearController.getActive,
  });

  //selected SchoolYear
  //fetch anne scolaire
  const { data: schoolYear } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  const schoolYearArr = schoolYear?.data || [];
  const selectedSchoolYear = schoolYearArr.find((sy: any) => sy.selected);

  //filter PromotionDataArr in which we have the current student to get the promotion corresponding to the current student and the selected school year

  const [CurrentSelectedSchoolYear, setCurrentSelectedSchoolYear] = useState<
    schooYearType | any
  >(selectedSchoolYear || null);

  useEffect(() => {
    setCurrentSelectedSchoolYear(selectedSchoolYear || null);
  }, [selectedSchoolYear]);

  // console.log(CurrentSelectedSchoolYear);

  //Handle mouse click outside for dropdowns
  const MenuDropdownRef = React.useRef<HTMLDivElement>(null);
  const logout = useLogout();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        MenuDropdownRef.current &&
        !MenuDropdownRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //payment form state

  const [password, setPassword] = useState("");

  const [paymentForm, setPaymentForm] = useState<{
    date: string;
    amount: any;
    type: any;
    method: string;
    status: any;
    isEditing: boolean;
    editingId?: any;
  }>({
    date: "",
    amount: "",
    type: 1,
    method: "Carte",
    status: 1,
    isEditing: false,
    editingId: null,
  });

  const [currentAttendanceId, SetCurrentAttendanceId] = useState<any>(null);
  const [currentAttendanceCoteId, SetCurrentAttendanceCoteId] =
    useState<any>(null);
  const [currentPaiementId, setCurrentPaiementId] = useState<any>(null);
  const [absenceForm, setAbsenceForm] = useState<{
    date: string;
    reason: string;
    status?: any;
    justified: boolean;
    isEditing: boolean;
    editingId: any;
  }>({
    date: "",
    reason: "",
    status: null,
    justified: false,
    isEditing: false,
    editingId: null,
  });

  // Fonction pour afficher une notification
  const [notification, setNotification] = useState<any>(null); // { message, type }
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const [isReceiptModalOpen, setIsReceiptModalOpen] = useState(false);
  // const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  // const [selectedHistoryFilter, setSelectedHistoryFilter] = useState("all");

  const [receiptData, setReceiptData] = useState<{
    id: string;
    date: string;
    amount: number;
    type: string;
    method: string;
    status: any;
    student: string;
    class: string;
    annee_scolaire_designation?: string;
  } | null>(null);

  //filter states for messages
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Tous");
  const [selectedType, setSelectedType] = useState("Tous les types");

  const [createMessageForm, setcreateMessageForm] = useState<{
    objet: any;
    contenu: string;
    destinateur_id: any;
    annee_scolaire_id?: any;
    canal: "email" | "sms" | "";
    status: any;
  }>({
    objet: "",
    contenu: "",
    destinateur_id: dataStudent?.parent_id || null,
    annee_scolaire_id: CurrentSelectedSchoolYear?.id, //selected sy id
    canal: "",
    status: 0,
  });

  // console.log("createMessageForm:", createMessageForm);

  const mutationsendEMAILtoOneParent = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoOneParent({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        parent_id: createMessageForm.destinateur_id,
      }),

    onSuccess: () => {
      // console.log(data);
      setIsContactModalOpen(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        destinateur_id: dataStudent?.parent_id || null,
        annee_scolaire_id: "",
        canal: "email",
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });

  const mutationsendSMStoOneParent = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoOneParent({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        parent_id: createMessageForm.destinateur_id,
      }),

    onSuccess: (data) => {
      setIsContactModalOpen(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        destinateur_id: dataStudent?.parent_id || null,
        annee_scolaire_id: "",
        canal: "email",
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: (err) => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });

  const isPendingMessage =
    mutationsendSMStoOneParent.isPending ||
    mutationsendEMAILtoOneParent.isPending;

  const handleSendMessage = () => {
    if (
      !createMessageForm.objet ||
      !createMessageForm.contenu ||
      !createMessageForm.destinateur_id
    )
      return showNotification("Tous les champs sont obligatoire", "erreur");

    if (!createMessageForm.canal) {
      return showNotification(
        "Veuillez sélectionner un canal de communication",
        "erreur",
      );
    }
    // Determine type_request based on canal and type_destinateur

    if (createMessageForm.canal === "sms") {
      //show notification if the phone number of the parent is not available
      if (!dataStudent.parentData.telephone) {
        return showNotification(
          "Le numéro de téléphone du parent est indisponible",
          "erreur",
        );
      }
      mutationsendSMStoOneParent.mutate();
    } else if (createMessageForm.canal === "email") {
      //show notification if the phone number of the parent is not available
      if (!dataStudent.parentData.email) {
        return showNotification("L'email du parent est indisponible", "erreur");
      }
      mutationsendEMAILtoOneParent.mutate();
    }
  };

  const queryClient = useQueryClient();

  //Update attendance
  const mutationUpdateAttendance = useMutation({
    mutationFn: () =>
      studentAttendanceController.update(currentAttendanceId, {
        justification: absenceForm.reason,
        cote_eleve_id: currentAttendanceCoteId,
      }),
    onSuccess: (data) => {
      // console.log(data);
      toast.success("Ponctualité modifiée avec succès!", {
        duration: 4000,
        position: "bottom-right",
        style: { background: "green", color: "#fff" },
      });

      setIsAbsenceModalOpen(false);
      queryClient.invalidateQueries({ queryKey: ["studentAttendance"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationAnnulerPayment = useMutation({
    mutationFn: () => paymentController.desactivate(currentPaiementId),
    onSuccess: (data) => {
      // console.log("desactivate Mutation", data);
      setShowCancelModal(false);
      showNotification("Annulation effectuée avec succès!", "success");

      setCurrentPaiementId(null);
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      // console.log(err);
      showNotification(
        " Une erreur est survenue lors de l'annulation!",
        "error",
      );
    },
  });

  //get User context && from localstorage
  const { user } = useAuth();
  //update payment & save new payement
  const mutationCreatePayment = useMutation({
    mutationFn: () =>
      paymentController.create({
        montant: paymentForm.amount,
        jour: moment().format("YYYY-MM-DD HH:mm"),
        motif_paiement_id: 1,
        eleve_id: dataStudent.eleve_id,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: CurrentSelectedSchoolYear?.id, //selected sy id
        // annee_scolaire_id: activeSchoolYear?.data[0].id,
        operation_id: `PAY-${moment().year()}-${moment().month()}-${moment().format(
          "DDHHMMSS",
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),
    onSuccess: (data) => {
      setIsPaymentModalOpen(false);
      showNotification("Paiement effectué avec succès!", "success");

      setPaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        isEditing: false,
        editingId: null,
      });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationUpdatePayment = useMutation({
    mutationFn: () =>
      paymentController.update(currentPaiementId, {
        montant: paymentForm.amount,
        jour: moment().format("YYYY-MM-DD HH:mm"),
        motif_paiement_id: 1,
        eleve_id: dataStudent.eleve_id,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: CurrentSelectedSchoolYear?.id, //selected sy id
        // annee_scolaire_id: activeSchoolYear?.data[0].id,
        operation_id: `INV-${moment().year()}-00${moment().format(
          "DDMMYYYYHHMMSS",
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),
    onSuccess: (data) => {
      // console.log("Update Mutation", data);
      setIsPaymentModalOpen(false);
      showNotification("Paiement modifié avec succès!", "success");

      setPaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        isEditing: false,
        editingId: null,
      });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const paymentActions: Record<PaymentAction, () => void> = {
    create: mutationCreatePayment.mutate,
    cancel: mutationAnnulerPayment.mutate,
  };
  const mutationLogin = useMutation({
    mutationFn: loginAPI,
    onSuccess: (data) => {
      if (data.token) {
        //after password correct call apdate function mutation
        if (!pendingPaiementAction) return;

        paymentActions[pendingPaiementAction]();

        setPendingPaiementAction(null);
      } else
        return showNotification(
          "Mot de passe incorrect, veuillez réessayer",
          "error",
        );
    },

    onError: (error) => {
      // console.log(error);
      setPassword("");
      return;
      // return showNotification("Une erreur s'est produite, réessayer", "error");
    },
  });

  const handleUpdateAttendance = () => {
    mutationUpdateAttendance.mutate();
  };

  //vérification du mot de passe
  const handleConfirmPassword = () => {
    if (!password)
      return showNotification("Veuillez compléter le mot de passe", "error");
    if (!user.email)
      return showNotification("Une erreur s'est produite, actualiser", "error");
    //call the login & update mutation functions
    mutationLogin.mutate({ email: user.email, password });
  };

  //fetch attendance of the current month
  const date = moment().format("YYYY-MM-DD");
  const { data: studentAttendance, isLoading: studentAttendanceLoading } =
    useQuery({
      queryKey: ["studentAttendance"],
      queryFn: () => studentAttendanceController.getAllByMonth(date),
      select: (data) =>
        data.filter(
          (attendance: PonctualiteType) =>
            attendance.eleve_id === dataStudent.eleve_id,
        ),
    });
  const studentAttendanceArr = Array.isArray(studentAttendance)
    ? studentAttendance
    : [];
  //fetch paiement of current student of cactive school year
  const { data: paiementData, isLoading: paiementDataLoading } = useQuery({
    queryKey: ["payments"],
    queryFn: paymentController.getAll,
  });

  //fetch all messages
  const { data: messagesData } = useQuery({
    queryKey: ["messages"],
    queryFn: messageControler.getAll,
  });

  let paiementDataArr = paiementData?.data || [];
  const paiementDataArrUpdates = paiementDataArr.map((item) => {
    //add schoolyear designation to paiement data
    const schoolYear = schoolYearArr.find(
      (sy: any) => sy.id === item.annee_scolaire_id,
    );
    return {
      ...item,
      annee_scolaire_designation: schoolYear ? schoolYear.designation : "N/A",
    };
  });

  paiementDataArr = [...paiementDataArrUpdates];

  const messageDataArray = messagesData?.data || [];

  const completeMessages = messageDataArray.map(
    (message: MessageType, index: number) => {
      let canalType =
        message.canal_mail === 1
          ? "Email"
          : message.canal_sms === 1
            ? "SMS"
            : message.canal_notification === 1
              ? "Soft SMS"
              : "Unset";
      return {
        id: index + 1,
        date: moment(message.created_at).format("DD/MM/YYYY"),
        heure: moment(message.created_at).format("HH:mm"),
        objet: capitalizeFirstLetter(message.objet),
        contenu: message.contenu,
        destinataires:
          message.type_destinateur_id === 1 ? "Parent" : "Professeur",
        destinataire_id: message.destinateur_id,
        Category: message.type_diffusion === "groupe" ? "Groupe" : "Individuel",
        type: canalType,
        statut: message.status === 1 ? "Envoyé" : "Brouillon",
      };
    },
  );

  // Filtrer les communications selon la recherche et les filtres
  const filteredMessages = completeMessages.filter((communication) => {
    const matchesSearch =
      communication.objet.toLowerCase().includes(searchQuery.toLowerCase()) ||
      communication.contenu.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory =
      selectedCategory === "Tous" ||
      communication.Category === selectedCategory;
    const matchesType =
      selectedType === "Tous les types" || communication.type === selectedType;

    return matchesSearch && matchesCategory && matchesType;
  });
  // console.log(filteredMessages);

  const filteredPaiementsForStudent = paiementDataArr?.filter((item) => {
    const matchEleveId = dataStudent.eleve_id === item.eleve_id;

    const matchSchoolYearId =
      CurrentSelectedSchoolYear?.id === item.annee_scolaire_id;

    return matchEleveId && matchSchoolYearId;
  });

  // const studentPaiements = paiementData ? paiementData : [];

  // fetch motif Paiement
  const { data: motifPaiementData, isLoading: motifPaiementLoading } = useQuery(
    {
      queryKey: ["motifPaiement"],
      queryFn: motifPaiementController.getAll,
    },
  );

  let motifPaiementArr = motifPaiementData ? motifPaiementData.data : [];

  //fetch promotion
  const { data: promotionsData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  //fetch classe
  const { data: classeData } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  const promotionDataArr = promotionsData?.data || [];
  const classeDataArr = classeData?.data || [];

  //filter classe when we select schoolYear for the student to get the montant
  // frais scolaire corresponding to this class and this annee scolaire
  let currentClasseId = dataStudent.classeId;
  let elevePromotionSyId: any = [];

  promotionDataArr.map((item: any) => {
    if (
      item.eleve_id === dataStudent.eleve_id &&
      item.annee_scolaire_id === CurrentSelectedSchoolYear?.id
    ) {
      currentClasseId = item.classe_id;
    }
    //push all the school year id of the student in elevePromotionSyId array to use it later to
    // filter the paiement of the student according to the selected school year

    if (item.eleve_id === dataStudent.eleve_id) {
      elevePromotionSyId.push(item.annee_scolaire_id);
    }

    return null;
  });

  //find current classe designation
  let currentClasseDesignation: any = "";
  classeDataArr.map((item) => {
    if (item.id === currentClasseId) {
      currentClasseDesignation = item.designation;
    }

    return null;
  });

  //in elevePromotionSyId array remove duplicates values
  elevePromotionSyId = [...new Set(elevePromotionSyId)];

  // in schoolYearArr find only the school year which id is in elevePromotionSyId array to
  // use it later to filter the paiement of the student according to the selected school year
  const studentSchoolYears = schoolYearArr.filter((item: any) =>
    elevePromotionSyId.includes(item.id),
  );

  // fetch Montant frais scolaire
  const { data: montantPerClasse, isLoading: montantPerClasseLoading } =
    useQuery({
      queryKey: ["montantPerClasse"],
      queryFn: montantController.getAll,
      //we select the current montant of current classe of current active school year
      select: (data) =>
        data.data.filter(
          (item) =>
            // item.annee_scolaire_id === selectedSchoolYear?.id &&
            item.annee_scolaire_id === CurrentSelectedSchoolYear?.id &&
            item.classe_id === currentClasseId,
        ),
    });

  // console.log(CurrentSelectedSchoolYear);
  // console.log(currentClasseId);
  // console.log(montantPerClasse);

  // Ici en haut on doit chercher la classe de l'eleve lorsqu'on change l'annee scolaire selectionné pour afficher le montant correspondant à cette année scolaire

  // eleveId
  // selectedAnneeId

  // MontantAll

  const montantPerClasseArr = montantPerClasse ? montantPerClasse : [];
  // console.log(montantPerClasseArr);
  const getPaymentAmount = () => {
    const annualTotal = montantPerClasseArr[0]
      ? montantPerClasseArr[0].montant
      : 0;

    //on fait la sommation des paiement avec status === 1
    const paiedTotal = filteredPaiementsForStudent
      .filter((item) => item.status === 1)
      .reduce((sum, paiement) => sum + paiement.montant, 0);
    const balanceTotal = annualTotal - paiedTotal;

    const percentage =
      annualTotal === 0 ? 0 : ((paiedTotal * 100) / annualTotal).toFixed(2);

    return {
      total: annualTotal,
      balance: balanceTotal,
      paid: paiedTotal,
      percentage,
    };
  };

  // console.log(getPaymentAmount().balance);
  // console.log(getPaymentAmount().paid);
  // console.log(getPaymentAmount().total);
  // console.log(paiementData);

  // Manage stats cards data
  const presenceArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 1,
    ) ?? [];
  const retardArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 2,
    ) ?? [];
  const absenceArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 3,
    ) ?? [];

  const retardAbsenceArr = [...retardArr, ...absenceArr];

  // console.log(studentAttendance);
  // console.log(retardAbsenceArr);
  // console.log(presenceArr);

  const presenceRate =
    presenceArr?.length &&
    retardAbsenceArr?.length &&
    presenceArr?.length + retardAbsenceArr?.length > 0
      ? (
          (presenceArr.length /
            (presenceArr.length + retardAbsenceArr.length)) *
          100
        ).toFixed(1)
      : 0;

  // Filtrer la ponctualité general des élèves selon les presences, retard et absence
  const filteredAttendanceList = studentAttendanceArr.filter((attendance) => {
    const matchesStatus =
      selectedStatusAttendance === "Tous les statuts" ||
      attendance.cote_eleve_id === selectedStatusAttendance;
    return matchesStatus;
  });

  // Filtrer a ponctualité des élèves selon retard et absence
  // const filteredAttendanceList = retardAbsenceArr.filter((attendance) => {
  //   // const filteredAttendanceList = studentAttendance.filter((attendance: any) => {
  //   const matchesStatus =
  //     selectedStatusAttendance === "Tous les statuts" ||
  //     attendance.cote_eleve_id === selectedStatusAttendance;
  //   return matchesStatus;
  // });

  // État pour le mode sombre
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  // Fonction pour basculer le mode sombre
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // This goes back to the previous page
  };

  // console.log(createMessageForm);
  return (
    <div className="md:ml-60 w-full">
      <MyLoader isLoading={isPendingMessage} message="Envoie en cours..." />
      <MyLoader
        isLoading={logout.isPending}
        message="Déconnexion en cours..."
      />
      {/* Header */}
      <header
        className={`fixed top-0 left-20 md:left-60 right-0 z-50 h-16 border-b transition-colors ${
          isDarkMode
            ? "border-[#30363D] bg-[#0D1117]/95"
            : "border-gray-200 bg-white/95"
        } backdrop-blur-md`}
      >
        <div className="flex h-full items-center justify-between gap-4 px-4 sm:px-5 lg:px-6">
          {/* ==================================================
        LEFT — BACK BUTTON
    ================================================== */}
          <div className="flex min-w-0 items-center">
            <button
              onClick={goBack}
              className={`group flex h-9 items-center gap-2.5 rounded-lg border px-3 transition ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                  : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              <div
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition ${
                  isDarkMode
                    ? "bg-blue-500/10 text-blue-400 group-hover:bg-blue-500/15"
                    : "bg-blue-50 text-blue-600 group-hover:bg-blue-100"
                }`}
              >
                <i className="fas fa-arrow-left text-[8px]" />
              </div>

              <div className="hidden text-left sm:block">
                <p
                  className={`whitespace-nowrap text-[10px] font-semibold leading-none ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Retour à la liste
                </p>
              </div>

              {/* Mobile */}
              <span
                className={`whitespace-nowrap text-[10px] font-medium sm:hidden ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Retour
              </span>
            </button>
          </div>

          {/* ==================================================
        RIGHT — ACTIONS
    ================================================== */}
          <div className="flex shrink-0 items-center gap-2">
            {/* Theme */}
            <button
              onClick={toggleDarkMode}
              title={isDarkMode ? "Mode clair" : "Mode sombre"}
              className={`flex h-9 w-9 items-center justify-center rounded-lg border transition ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22] text-amber-400 hover:bg-[#21262D]"
                  : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              {isDarkMode ? (
                <LightModeOutlined sx={{ fontSize: 16 }} />
              ) : (
                <i className="fas fa-moon text-[11px]" />
              )}
            </button>

            {/* Separator */}
            <div
              className={`mx-1 hidden h-6 w-px sm:block ${
                isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
              }`}
            />

            {/* ==================================================
          USER ACCOUNT
      ================================================== */}
            <div className="relative" ref={MenuDropdownRef}>
              <button
                id="userMenuButton"
                onClick={toggleUserMenu}
                className={`group flex h-10 items-center gap-2 rounded-xl border p-1 pr-1 transition sm:pr-2 ${
                  isUserMenuOpen
                    ? isDarkMode
                      ? "border-blue-500/40 bg-[#161B22]"
                      : "border-blue-200 bg-blue-50/50"
                    : isDarkMode
                      ? "border-transparent hover:border-[#30363D] hover:bg-[#161B22]"
                      : "border-transparent hover:border-gray-200 hover:bg-gray-50"
                }`}
              >
                {/* Avatar */}
                <div
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-50 text-blue-600"
                  }`}
                >
                  <i className="fas fa-user text-[10px]" />
                </div>

                {/* Account information */}
                <div className="hidden max-w-[150px] min-w-0 text-left lg:block">
                  <p
                    className={`truncate text-[10px] font-semibold leading-tight ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Mon compte
                  </p>

                  <p className="mt-0.5 truncate text-[8px] leading-tight text-gray-500">
                    {user?.email}
                  </p>
                </div>

                <i
                  className={`fas fa-chevron-down hidden text-[7px] text-gray-500 transition-transform duration-200 sm:block ${
                    isUserMenuOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* ==================================================
            USER DROPDOWN
        ================================================== */}
              {isUserMenuOpen && (
                <div
                  className={`absolute right-0 top-full mt-2 w-[280px] overflow-hidden rounded-xl border shadow-2xl ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#161B22]"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  {/* ================= ACCOUNT HEADER ================= */}
                  <div
                    className={`border-b p-3.5 ${
                      isDarkMode ? "border-[#30363D]" : "border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {/* Avatar */}
                      <div
                        className={`relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user text-xs" />

                        {/* Online status */}
                        <span
                          className={`absolute -bottom-0.5 -right-0.5 flex h-3 w-3 items-center justify-center rounded-full ${
                            isDarkMode ? "bg-[#161B22]" : "bg-white"
                          }`}
                        >
                          <span className="h-2 w-2 rounded-full bg-emerald-500" />
                        </span>
                      </div>

                      {/* Account info */}
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-1.5">
                          <p
                            className={`text-[11px] font-semibold ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            Mon compte
                          </p>

                          <span
                            className={`rounded-full px-1.5 py-0.5 text-[7px] font-medium ${
                              isDarkMode
                                ? "bg-emerald-500/10 text-emerald-400"
                                : "bg-emerald-50 text-emerald-600"
                            }`}
                          >
                            Actif
                          </span>
                        </div>

                        <p
                          className="mt-1 truncate text-[9px] text-gray-500"
                          title={user?.email}
                        >
                          {user?.email}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* ================= MENU ================= */}
                  <div className="p-1.5">
                    {/* Profile */}
                    <Link
                      to="/profil"
                      className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 transition ${
                        isDarkMode
                          ? "text-gray-300 hover:bg-[#21262D]"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user-circle text-[10px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[10px] font-medium">
                          Voir le profil
                        </p>

                        <p className="mt-0.5 text-[8px] text-gray-500">
                          Informations personnelles
                        </p>
                      </div>

                      <i className="fas fa-chevron-right text-[7px] text-gray-500 opacity-0 transition group-hover:opacity-100" />
                    </Link>

                    {/* Settings */}
                    <HasRole allowedRoles={["Administrateur", "Comptable"]}>
                      <Link
                        to="/parametre"
                        className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 transition ${
                          isDarkMode
                            ? "text-gray-300 hover:bg-[#21262D]"
                            : "text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        <div
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                            isDarkMode
                              ? "bg-purple-500/10 text-purple-400"
                              : "bg-purple-50 text-purple-600"
                          }`}
                        >
                          <i className="fas fa-cog text-[10px]" />
                        </div>

                        <div className="min-w-0 flex-1">
                          <p className="text-[10px] font-medium">Paramètres</p>

                          <p className="mt-0.5 text-[8px] text-gray-500">
                            Configuration de l'application
                          </p>
                        </div>

                        <i className="fas fa-chevron-right text-[7px] text-gray-500 opacity-0 transition group-hover:opacity-100" />
                      </Link>
                    </HasRole>
                  </div>

                  {/* ================= LOGOUT ================= */}
                  <div
                    className={`border-t p-1.5 ${
                      isDarkMode ? "border-[#30363D]" : "border-gray-200"
                    }`}
                  >
                    <button
                      onClick={() => logout.mutate()}
                      className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition ${
                        isDarkMode
                          ? "text-red-400 hover:bg-red-500/10"
                          : "text-red-600 hover:bg-red-50"
                      }`}
                    >
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode ? "bg-red-500/10" : "bg-red-50"
                        }`}
                      >
                        <i className="fas fa-sign-out-alt text-[10px]" />
                      </div>

                      <div className="flex-1">
                        <p className="text-[10px] font-medium">Déconnexion</p>

                        <p
                          className={`mt-0.5 text-[8px] ${
                            isDarkMode ? "text-gray-500" : "text-gray-400"
                          }`}
                        >
                          Fermer votre session
                        </p>
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {studentAttendanceLoading ||
      activeSchoolYearLoading ||
      paiementDataLoading ||
      motifPaiementLoading ||
      montantPerClasseLoading ? (
        <StudentProfileSkeleton isDarkMode={isDarkMode} />
      ) : (
        <div className="ml-20 md:ml-0">
          {/* Student Profile Header */}
          <div
            className={`px-2 lg:px-6 py-6 border-b mt-12 lg:mt-16 ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            }`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <div
                  className={`w-8 h-8 lg:w-12 lg:h-12 rounded-full flex items-center justify-center ${
                    isDarkMode ? "bg-blue-600" : "bg-blue-500"
                  } text-white text-2xl font-bold`}
                >
                  {dataStudent?.nom
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <div className="ml-4">
                  <h1 className="text-xs md:text-sm lg:text-xl font-medium">
                    {" "}
                    {dataStudent?.nom} {dataStudent?.postnom}{" "}
                    {capitalizeFirstLetter(dataStudent?.prenom)}
                  </h1>
                  <div className="flex items-center mt-1">
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        dataStudent?.status
                          ? "bg-green-400 text-green-800"
                          : "bg-red-100 text-red-800"
                      } mr-2`}
                    >
                      {dataStudent?.status ? "Active" : "Inactive"}
                    </span>
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        isDarkMode ? "bg-gray-700" : "bg-gray-200"
                      }`}
                    >
                      {currentClasseDesignation}
                      {/* {dataStudent?.classeDesignation
                        ? dataStudent?.classeDesignation
                        : "----------"} */}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-3">
                {/* <button
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-print mr-2"></i>
              <span>Imprimer</span>
            </button> */}
                {activeTab === "paiements" && (
                  <div
                    className={`relative border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md`}
                  >
                    <select
                      className={`appearance-none w-full px-3 h-8 rounded-md text-sm ${
                        isDarkMode ? "bg-[#161B22]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value) {
                          setCurrentSelectedSchoolYear(null);
                          return;
                        }
                        const obj = JSON.parse(value);
                        setCurrentSelectedSchoolYear(obj);
                      }}
                    >
                      {/* we filter the school year of the student using the elevePromotionSyId array that we create before to push the school year id of the student in it and use it to filter the school year in the select options to show only the school year that have promotion with this student */}
                      {studentSchoolYears.map((yearItem: any) => {
                        return (
                          <option
                            selected={yearItem.selected ? true : false}
                            key={yearItem.id}
                            value={JSON.stringify(yearItem)}
                          >
                            {yearItem.designation}
                          </option>
                        );
                      })}
                    </select>
                    {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500">
                      <i className="fas fa-chevron-down"></i>
                    </div> */}
                  </div>
                )}
                {(dataStudent.parentData.telephone ||
                  dataStudent.parentData.email) && (
                  <button
                    id="contactBtn"
                    onClick={() => setIsContactModalOpen(true)}
                    className={`hidden px-4 md:flex items-center md:justify-start md:gap-2 rounded-md ${
                      isDarkMode
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white !rounded-button whitespace-nowrap`}
                  >
                    <i className="fas fa-envelope py-2"></i>
                    <span className="hidden lg:flex text-xs">Contacter</span>
                  </button>
                )}

                {/* ?essage Contact Modal */}
                {isContactModalOpen && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
                    <div
                      className={`relative flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl border shadow-2xl ${
                        isDarkMode
                          ? "border-[#30363D] bg-[#161B22]"
                          : "border-gray-200 bg-white"
                      }`}
                    >
                      {/* ================= HEADER ================= */}
                      <div
                        className={`flex shrink-0 items-center justify-between gap-4 border-b px-5 py-3.5 ${
                          isDarkMode ? "border-[#30363D]" : "border-gray-200"
                        }`}
                      >
                        <div className="flex min-w-0 items-center gap-3">
                          <div
                            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                              isDarkMode
                                ? "bg-blue-500/10 text-blue-400"
                                : "bg-blue-50 text-blue-600"
                            }`}
                          >
                            <i className="fas fa-paper-plane text-xs" />
                          </div>

                          <div className="min-w-0">
                            <h3
                              className={`text-sm font-semibold ${
                                isDarkMode ? "text-gray-100" : "text-gray-900"
                              }`}
                            >
                              Nouveau message
                            </h3>

                            <p className="mt-0.5 text-[9px] text-gray-500">
                              Envoyez une communication au parent de l'élève
                            </p>
                          </div>
                        </div>

                        <button
                          type="button"
                          onClick={() => {
                            setIsContactModalOpen(false);
                            setcreateMessageForm({
                              objet: "",
                              contenu: "",
                              annee_scolaire_id: "",
                              destinateur_id: dataStudent?.parent_id || null,
                              canal: "email",
                              status: 0,
                            });
                          }}
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border transition ${
                            isDarkMode
                              ? "border-[#30363D] text-gray-400 hover:bg-[#21262D] hover:text-white"
                              : "border-gray-200 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                          }`}
                        >
                          <i className="fas fa-times text-[10px]" />
                        </button>
                      </div>

                      {/* ================= CONTENT ================= */}
                      <div className="flex-1 overflow-y-auto px-5 py-4">
                        <div className="space-y-5">
                          {/* ==================================================
              1. DESTINATAIRE + CANAL
          ================================================== */}
                          <section>
                            <div className="mb-2.5 flex items-center gap-2">
                              <div
                                className={`flex h-7 w-7 items-center justify-center rounded-lg ${
                                  isDarkMode
                                    ? "bg-[#21262D] text-gray-400"
                                    : "bg-gray-100 text-gray-500"
                                }`}
                              >
                                <i className="fas fa-user text-[9px]" />
                              </div>

                              <div>
                                <p
                                  className={`text-[11px] font-semibold ${
                                    isDarkMode
                                      ? "text-gray-200"
                                      : "text-gray-800"
                                  }`}
                                >
                                  Destinataire
                                </p>

                                <p className="text-[8px] text-gray-500">
                                  Parent auquel cette communication sera envoyée
                                </p>
                              </div>
                            </div>

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_180px]">
                              {/* Parent */}
                              <div
                                className={`flex h-12 items-center gap-3 rounded-xl border px-3.5 ${
                                  isDarkMode
                                    ? "border-[#30363D] bg-[#0D1117]"
                                    : "border-gray-200 bg-gray-50"
                                }`}
                              >
                                <div
                                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                                    isDarkMode
                                      ? "bg-blue-500/10 text-blue-400"
                                      : "bg-blue-50 text-blue-600"
                                  }`}
                                >
                                  <i className="fas fa-user-check text-[10px]" />
                                </div>

                                <div className="min-w-0">
                                  <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                                    Parent
                                  </p>

                                  <p
                                    className={`mt-0.5 truncate text-[11px] font-semibold ${
                                      isDarkMode
                                        ? "text-gray-200"
                                        : "text-gray-800"
                                    }`}
                                  >
                                    {dataStudent.parentData?.nom ||
                                    dataStudent.parentData?.postnom ||
                                    dataStudent.parentData?.prenom
                                      ? `${dataStudent.parentData?.nom} ${capitalizeFirstLetter(
                                          dataStudent.parentData?.prenom,
                                        )}`
                                      : "----------------"}
                                  </p>
                                </div>
                              </div>

                              {/* Mode d'envoi */}
                              <div className="mt-[-10px]">
                                <label
                                  className={`mb-1.5 block text-[9px] font-medium uppercase tracking-wide ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-500"
                                  }`}
                                >
                                  Mode d'envoi
                                </label>

                                <div className="relative">
                                  <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    <i
                                      className={`fas ${
                                        createMessageForm.canal === "sms"
                                          ? "fa-comment-sms"
                                          : "fa-envelope"
                                      } text-[10px] text-gray-500`}
                                    />
                                  </div>

                                  <select
                                    value={createMessageForm.canal}
                                    className={`h-8 w-full appearance-none rounded-lg border pl-9 pr-8 text-xs font-medium outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                      isDarkMode
                                        ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                                        : "border-gray-200 bg-white text-gray-700"
                                    }`}
                                    onChange={(e) => {
                                      setcreateMessageForm((prev) => ({
                                        ...prev,
                                        canal: e.target.value as
                                          | "sms"
                                          | "email",
                                      }));
                                    }}
                                  >
                                    <option value="">
                                      Sélectionner un canal
                                    </option>
                                    {dataStudent.parentData.telephone && (
                                      <option value="sms">SMS</option>
                                    )}

                                    {dataStudent.parentData.email && (
                                      <option value="email">Email</option>
                                    )}
                                  </select>

                                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500">
                                    <i className="fas fa-chevron-down text-[8px]" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>

                          {/* ==================================================
              2. OBJET
          ================================================== */}
                          <section>
                            <label
                              className={`mb-1.5 flex items-center gap-2 text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-heading text-[9px] text-gray-500" />
                              Objet
                            </label>

                            <div className="relative">
                              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <i className="fas fa-tag text-[9px] text-gray-500" />
                              </div>

                              <input
                                type="text"
                                className={`h-10 w-full rounded-lg border pl-9 pr-3 text-xs outline-none transition placeholder:text-gray-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                  isDarkMode
                                    ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                                    : "border-gray-200 bg-white text-gray-700"
                                }`}
                                placeholder="Objet du message"
                                value={createMessageForm.objet}
                                onChange={(e) =>
                                  setcreateMessageForm((prev) => ({
                                    ...prev,
                                    objet: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </section>

                          {/* ==================================================
              3. CONTENU
          ================================================== */}
                          <section>
                            <div className="mb-1.5 flex items-center justify-between gap-4">
                              <label
                                className={`flex items-center gap-2 text-[10px] font-medium ${
                                  isDarkMode ? "text-gray-300" : "text-gray-700"
                                }`}
                              >
                                <i className="fas fa-align-left text-[9px] text-gray-500" />
                                Contenu du message
                              </label>

                              {createMessageForm.canal === "sms" && (
                                <div
                                  className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[9px] font-medium ${
                                    createMessageForm.contenu.length >= 300
                                      ? isDarkMode
                                        ? "bg-amber-500/10 text-amber-400"
                                        : "bg-amber-50 text-amber-600"
                                      : isDarkMode
                                        ? "bg-[#21262D] text-gray-400"
                                        : "bg-gray-100 text-gray-500"
                                  }`}
                                >
                                  <i className="fas fa-font text-[8px]" />
                                  <span id="smsCharCount">
                                    {createMessageForm.contenu.length}
                                  </span>{" "}
                                  <span>/ 320 caractères (SMS)</span>
                                </div>
                              )}
                            </div>

                            <div
                              className={`overflow-hidden rounded-xl border transition focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#0D1117]"
                                  : "border-gray-200 bg-white"
                              }`}
                            >
                              {/* Toolbar */}
                              <div
                                className={`flex h-9 items-center gap-1 border-b px-2 ${
                                  isDarkMode
                                    ? "border-[#30363D] bg-[#161B22]"
                                    : "border-gray-200 bg-gray-50"
                                }`}
                              >
                                <button
                                  className={`flex h-7 w-7 items-center justify-center rounded-md transition ${
                                    isDarkMode
                                      ? "text-gray-500 hover:bg-[#21262D]"
                                      : "text-gray-400 hover:bg-gray-200"
                                  }`}
                                >
                                  <i className="fas fa-italic text-[10px]" />
                                </button>

                                <button
                                  className={`flex h-7 w-7 items-center justify-center rounded-md transition ${
                                    isDarkMode
                                      ? "text-gray-500 hover:bg-[#21262D]"
                                      : "text-gray-400 hover:bg-gray-200"
                                  }`}
                                >
                                  <i className="fas fa-underline text-[10px]" />
                                </button>

                                <span
                                  className={`mx-1 h-4 w-px ${
                                    isDarkMode ? "bg-[#30363D]" : "bg-gray-300"
                                  }`}
                                />

                                <button
                                  className={`flex h-7 w-7 items-center justify-center rounded-md transition ${
                                    isDarkMode
                                      ? "text-gray-500 hover:bg-[#21262D]"
                                      : "text-gray-400 hover:bg-gray-200"
                                  }`}
                                >
                                  <i className="fas fa-list-ul text-[10px]" />
                                </button>

                                <span
                                  className={`mx-1 h-4 w-px ${
                                    isDarkMode ? "bg-[#30363D]" : "bg-gray-300"
                                  }`}
                                />

                                {/* Canal indicator */}
                                <div className="ml-auto flex items-center gap-1.5 pr-1 text-[8px] text-gray-500">
                                  <i
                                    className={`fas ${
                                      createMessageForm.canal === "sms"
                                        ? "fa-comment-sms"
                                        : "fa-envelope"
                                    } text-[8px]`}
                                  />

                                  {createMessageForm.canal === "sms"
                                    ? "SMS"
                                    : "Email"}
                                </div>
                              </div>

                              <textarea
                                placeholder="Ecrire..."
                                className={`min-h-[150px] w-full resize-y border-none px-3.5 py-3 text-xs font-normal leading-relaxed outline-none ${
                                  isDarkMode
                                    ? "bg-[#0D1117] text-gray-200 placeholder:text-gray-600"
                                    : "bg-white text-gray-700 placeholder:text-gray-400"
                                }`}
                                rows={5}
                                value={createMessageForm.contenu}
                                onChange={(e) => {
                                  if (
                                    createMessageForm.canal === "sms" &&
                                    e.target.value.length > 320
                                  ) {
                                    setcreateMessageForm((prev) => ({
                                      ...prev,
                                      contenu: e.target.value.substring(0, 320),
                                    }));
                                  } else {
                                    setcreateMessageForm((prev) => ({
                                      ...prev,
                                      contenu: e.target.value,
                                    }));
                                  }
                                }}
                              ></textarea>
                            </div>

                            {/* Helper */}
                            <div className="mt-1.5 flex items-center gap-1.5 px-1">
                              <i className="fas fa-info-circle text-[8px] text-gray-500" />

                              <p className="text-[8px] text-gray-500">
                                {createMessageForm.canal === "sms"
                                  ? "Le contenu SMS est limité à 320 caractères."
                                  : "Rédigez clairement le contenu de votre message."}
                              </p>
                            </div>
                          </section>
                        </div>
                      </div>

                      {/* ================= FOOTER ================= */}
                      <div
                        className={`flex shrink-0 flex-col-reverse gap-2 border-t px-5 py-3.5 sm:flex-row sm:items-center sm:justify-between ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117]/40"
                            : "border-gray-200 bg-gray-50/70"
                        }`}
                      >
                        <div className="hidden items-center gap-2 sm:flex">
                          <div
                            className={`flex h-6 w-6 items-center justify-center rounded-md ${
                              isDarkMode
                                ? "bg-blue-500/10 text-blue-400"
                                : "bg-blue-50 text-blue-600"
                            }`}
                          >
                            <i className="fas fa-info text-[8px]" />
                          </div>

                          <p className="text-[8px] text-gray-500">
                            Vérifiez le contenu avant d'envoyer le message.
                          </p>
                        </div>

                        <div className="flex items-center justify-end gap-2">
                          <button
                            onClick={() => {
                              setIsContactModalOpen(false);
                              setcreateMessageForm({
                                objet: "",
                                contenu: "",
                                destinateur_id: dataStudent?.parent_id || null,
                                annee_scolaire_id: "",
                                canal: "email",
                                status: 0,
                              });
                            }}
                            className={`flex h-9 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                                : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                            }`}
                          >
                            <i className="fas fa-times text-[9px]" />
                            Annuler
                          </button>

                          <button
                            disabled={isPendingMessage}
                            onClick={handleSendMessage}
                            className={`flex h-9 items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700 ${
                              isPendingMessage
                                ? "cursor-not-allowed opacity-70"
                                : ""
                            }`}
                          >
                            {isPendingMessage ? (
                              <>
                                <i className="fas fa-circle-notch fa-spin text-[9px]" />
                                Envoie en cours...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-paper-plane text-[9px]" />
                                Envoyer message
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Tabs Navigation */}
          <div
            className={`px-6 border-b ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            }`}
          >
            <div className="flex justify-between lg:justify-start space-x-1 overflow-x-auto">
              <button
                title="Info"
                onClick={() => setActiveTab("informations")}
                className={`px-4 py-3 font-medium text-sm border-b-2 ${
                  activeTab === "informations"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-600 text-blue-600"
                      }`
                    : `border-transparent ${
                        isDarkMode
                          ? "hover:text-gray-300"
                          : "hover:text-gray-700"
                      }`
                } !rounded-button whitespace-nowrap cursor-pointer`}
              >
                <i className="fas fa-user lg:mr-2"></i>
                <span className="lg:hidden text-xs">Info</span>
                <span className="hidden lg:inline text-xs">
                  {" "}
                  Informations personnelles
                </span>
              </button>
              <button
                title="Parent"
                onClick={() => setActiveTab("parents")}
                className={`px-4 py-3 font-medium text-sm border-b-2 ${
                  activeTab === "parents"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-600 text-blue-600"
                      }`
                    : `border-transparent ${
                        isDarkMode
                          ? "hover:text-gray-300"
                          : "hover:text-gray-700"
                      }`
                } !rounded-button whitespace-nowrap cursor-pointer`}
              >
                <i className="fas fa-people-group lg:mr-2"></i>
                <span className="hidden md:inline text-xs"> Parent</span>
              </button>

              <button
                title="Ponctualité"
                onClick={() => setActiveTab("absences")}
                className={`px-4 py-3 font-medium text-sm border-b-2 ${
                  activeTab === "absences"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-600 text-blue-600"
                      }`
                    : `border-transparent ${
                        isDarkMode
                          ? "hover:text-gray-300"
                          : "hover:text-gray-700"
                      }`
                } !rounded-button whitespace-nowrap cursor-pointer`}
              >
                <i className="fas fa-user-clock lg:mr-2"></i>

                <span className="hidden md:inline text-xs"> Ponctualité</span>
              </button>
              <button
                title="Frais"
                onClick={() => setActiveTab("paiements")}
                className={`px-4 py-3 font-medium text-sm border-b-2 ${
                  activeTab === "paiements"
                    ? `${
                        isDarkMode
                          ? "border-blue-500 text-blue-500"
                          : "border-blue-600 text-blue-600"
                      }`
                    : `border-transparent ${
                        isDarkMode
                          ? "hover:text-gray-300"
                          : "hover:text-gray-700"
                      }`
                } !rounded-button whitespace-nowrap cursor-pointer`}
              >
                <i className="fas fa-wallet lg:mr-2"></i>
                <span className="hidden md:inline text-xs"> Frais</span>{" "}
              </button>
              <button
                title="Message"
                onClick={() => setActiveTab("messages")}
                className={`px-4 py-3 font-medium text-sm border-b-2 ${
                  activeTab === "messages"
                    ? `${isDarkMode ? "border-blue-500 text-blue-500" : "border-blue-600 text-blue-600"}`
                    : `border-transparent ${isDarkMode ? "hover:text-gray-300" : "hover:text-gray-700"}`
                } !rounded-button whitespace-nowrap cursor-pointer`}
              >
                <i className="fas fa-comment-dots lg:mr-2"></i>
                <span className="hidden lg:inline text-xs"> Message</span>
              </button>
            </div>
          </div>
          {/* Tab Content */}
          <div className="p-6">
            {/* Informations personnelles */}
            {/* Informations personnelles */}
            {activeTab === "informations" && (
              <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mb-10">
                {/* ===================================================== */}
                {/* INFORMATIONS GÉNÉRALES */}
                {/* ===================================================== */}

                <div
                  className={`xl:col-span-2 rounded-xl border overflow-hidden ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  {/* Header */}
                  <div
                    className={`px-5 py-4 flex items-center justify-between border-b ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user text-sm"></i>
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Informations générales
                        </h3>

                        <p
                          className={`text-[11px] mt-0.5 ${
                            isDarkMode ? "text-gray-500" : "text-gray-400"
                          }`}
                        >
                          Informations personnelles de l'élève
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
                      {/* Nom */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-id-card text-xs"></i>
                        </div>

                        <div className="min-w-0">
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Nom complet
                          </p>

                          <p className="text-sm font-semibold truncate">
                            {dataStudent?.nom} {dataStudent?.postnom}{" "}
                            {dataStudent?.prenom}
                          </p>
                        </div>
                      </div>

                      {/* Contact */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-phone text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Contact
                          </p>

                          <p className="text-sm font-semibold">
                            {dataStudent?.telephone || "Non renseigné"}
                          </p>
                        </div>
                      </div>

                      {/* Naissance */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-calendar-alt text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Date de naissance
                          </p>

                          <div className="flex items-center flex-wrap gap-2">
                            <p className="text-sm font-semibold">
                              {moment(dataStudent?.date_naissance).format(
                                "DD/MM/YYYY",
                              )}
                            </p>

                            <span
                              className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
                                isDarkMode
                                  ? "bg-blue-500/10 text-blue-400"
                                  : "bg-blue-50 text-blue-600"
                              }`}
                            >
                              {moment().diff(
                                moment(
                                  dataStudent?.date_naissance,
                                  "YYYY-MM-DD",
                                ),
                                "years",
                              )}{" "}
                              ans
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Email */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-envelope text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Email
                          </p>

                          <p
                            className={`text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                          >
                            Non renseigné
                          </p>
                        </div>
                      </div>

                      {/* Genre */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-venus-mars text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Genre
                          </p>

                          <p className="text-sm font-semibold">
                            {dataStudent?.sexe === "M" ? "Masculin" : "Féminin"}
                          </p>
                        </div>
                      </div>

                      {/* Date inscription */}
                      <div
                        className={`flex gap-3 py-4 border-b ${
                          isDarkMode ? "border-[#21262D]" : "border-gray-100"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-calendar-check text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Date d'inscription
                          </p>

                          <p className="text-sm font-semibold">
                            {moment(dataStudent?.created_at).format(
                              "DD/MM/YYYY",
                            )}
                          </p>
                        </div>
                      </div>

                      {/* Adresse */}
                      <div className="flex gap-3 py-4">
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-map-marker-alt text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Adresse
                          </p>

                          <p className="text-sm font-semibold leading-5">
                            {capitalizeFirstLetter(dataStudent?.ville)}
                            {", "}
                            {capitalizeFirstLetter(dataStudent?.quartier)}
                            {", "}
                            {capitalizeFirstLetter(dataStudent?.avenue)}
                          </p>
                        </div>
                      </div>

                      {/* Classe */}
                      <div className="flex gap-3 py-4">
                        <div
                          className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className="fas fa-school text-xs"></i>
                        </div>

                        <div>
                          <p
                            className={`text-[11px] font-medium mb-1 ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Classe actuelle
                          </p>

                          {dataStudent?.classeDesignation ? (
                            <span
                              className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold ${
                                isDarkMode
                                  ? "bg-blue-500/10 text-blue-400"
                                  : "bg-blue-50 text-blue-600"
                              }`}
                            >
                              <i className="fas fa-graduation-cap mr-1.5 text-[10px]"></i>

                              {dataStudent.classeDesignation}
                            </span>
                          ) : (
                            <p className="text-sm text-gray-500">Non affecté</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===================================================== */}
                {/* INFORMATIONS MÉDICALES */}
                {/* ===================================================== */}

                <div
                  className={`rounded-xl border overflow-hidden ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  {/* Header */}
                  <div
                    className={`px-5 py-4 border-b ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-red-500/10 text-red-400"
                            : "bg-red-50 text-red-500"
                        }`}
                      >
                        <i className="fas fa-heartbeat text-sm"></i>
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Informations médicales
                        </h3>

                        <p
                          className={`text-[11px] mt-0.5 ${
                            isDarkMode ? "text-gray-500" : "text-gray-400"
                          }`}
                        >
                          Données de santé importantes
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 space-y-1">
                    {/* Allergies */}
                    <div
                      className={`flex items-center justify-between gap-4 py-3.5 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <i className="fas fa-allergies text-red-400 w-4 text-center"></i>

                        <span
                          className={`text-xs ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Allergies
                        </span>
                      </div>

                      <span className="text-xs font-semibold">
                        Non renseigné
                      </span>
                    </div>

                    {/* Médicaments */}
                    <div
                      className={`flex items-center justify-between gap-4 py-3.5 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <i className="fas fa-pills text-blue-400 w-4 text-center"></i>

                        <span
                          className={`text-xs ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Médicaments
                        </span>
                      </div>

                      <span className="text-xs font-semibold">
                        Non renseigné
                      </span>
                    </div>

                    {/* Groupe sanguin */}
                    <div
                      className={`flex items-center justify-between gap-4 py-3.5 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <i className="fas fa-tint text-red-500 w-4 text-center"></i>

                        <span
                          className={`text-xs ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Groupe sanguin
                        </span>
                      </div>

                      <span
                        className={`px-2 py-1 rounded-md text-[11px] font-semibold ${
                          isDarkMode
                            ? "bg-gray-800 text-gray-400"
                            : "bg-gray-100 text-gray-500"
                        }`}
                      >
                        Non renseigné
                      </span>
                    </div>

                    {/* Médecin */}
                    <div
                      className={`flex items-center justify-between gap-4 py-3.5 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <i className="fas fa-user-md text-emerald-400 w-4 text-center"></i>

                        <span
                          className={`text-xs ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Médecin traitant
                        </span>
                      </div>

                      <span className="text-xs font-semibold">
                        Non renseigné
                      </span>
                    </div>

                    {/* Téléphone médecin */}
                    <div className="flex items-center justify-between gap-4 py-3.5">
                      <div className="flex items-center gap-3">
                        <i className="fas fa-phone-alt text-gray-400 w-4 text-center"></i>

                        <span
                          className={`text-xs ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Téléphone du médecin
                        </span>
                      </div>

                      <span className="text-xs font-semibold">
                        Non renseigné
                      </span>
                    </div>
                  </div>

                  {/* Medical information status */}
                  <div
                    className={`mx-5 mb-5 p-3 rounded-lg border flex items-start gap-2.5 ${
                      isDarkMode
                        ? "bg-amber-500/5 border-amber-500/20"
                        : "bg-amber-50 border-amber-100"
                    }`}
                  >
                    <i className="fas fa-info-circle text-amber-500 mt-0.5 text-xs"></i>

                    <p
                      className={`text-[11px] leading-4 ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Les informations médicales de cet élève ne sont pas encore
                      renseignées.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {/* Parents */}
            {/* Parents */}
            {activeTab === "parents" && (
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
                {/* Informations principales */}
                <div
                  className={`rounded-xl border overflow-hidden ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  {/* Header */}
                  <div
                    className={`px-5 py-4 flex items-center justify-between border-b ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user-friends text-sm" />
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Parent / Responsable
                        </h3>
                        <p
                          className={`text-[11px] mt-0.5 ${
                            isDarkMode ? "text-gray-500" : "text-gray-400"
                          }`}
                        >
                          Informations du responsable de l'élève
                        </p>
                      </div>
                    </div>

                    <button
                      id={`contactParentBtn-${1}`}
                      onClick={() => setIsContactModalOpen(true)}
                      title="Contacter le parent"
                      className={`w-9 h-9 rounded-lg flex items-center justify-center transition ${
                        isDarkMode
                          ? "bg-blue-500/10 text-blue-400 hover:bg-blue-500/20"
                          : "bg-blue-50 text-blue-600 hover:bg-blue-100"
                      }`}
                    >
                      <i className="fas fa-envelope text-xs" />
                    </button>
                  </div>

                  <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-x-8">
                    {/* Noms */}
                    <div
                      className={`flex gap-3 py-4 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="w-8 h-8 rounded-lg bg-blue-500/10 text-blue-500 flex items-center justify-center shrink-0">
                        <i className="fas fa-user text-xs" />
                      </div>

                      <div>
                        <p className="text-[11px] text-gray-500 mb-1">
                          Nom complet
                        </p>
                        <p className="text-sm font-semibold">
                          {dataStudent.parentData?.nom ||
                          dataStudent.parentData?.postnom ||
                          dataStudent.parentData?.prenom
                            ? `${dataStudent.parentData?.nom} ${capitalizeFirstLetter(
                                dataStudent.parentData?.prenom,
                              )}`
                            : "Non renseigné"}
                        </p>
                      </div>
                    </div>

                    {/* Parenté */}
                    <div
                      className={`flex gap-3 py-4 border-b ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="w-8 h-8 rounded-lg bg-purple-500/10 text-purple-500 flex items-center justify-center shrink-0">
                        <i className="fas fa-people-arrows text-xs" />
                      </div>

                      <div>
                        <p className="text-[11px] text-gray-500 mb-1">
                          Lien de parenté
                        </p>
                        <span
                          className={`inline-flex px-2.5 py-1 rounded-md text-xs font-semibold ${
                            isDarkMode
                              ? "bg-purple-500/10 text-purple-400"
                              : "bg-purple-50 text-purple-600"
                          }`}
                        >
                          {capitalizeFirstLetter(dataStudent.parentData.type) ||
                            "Non renseigné"}
                        </span>
                      </div>
                    </div>

                    {/* Téléphone */}
                    <div
                      className={`flex gap-3 py-4 border-b sm:border-b-0 ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div className="w-8 h-8 rounded-lg bg-green-500/10 text-green-500 flex items-center justify-center shrink-0">
                        <i className="fas fa-phone-alt text-xs" />
                      </div>

                      <div>
                        <p className="text-[11px] text-gray-500 mb-1">
                          Téléphone
                        </p>
                        <p className="text-sm font-semibold">
                          {dataStudent.parentData.telephone || "Non renseigné"}
                        </p>
                      </div>
                    </div>

                    {/* Email */}
                    <div className="flex gap-3 py-4">
                      <div className="w-8 h-8 rounded-lg bg-amber-500/10 text-amber-500 flex items-center justify-center shrink-0">
                        <i className="fas fa-envelope text-xs" />
                      </div>

                      <div className="min-w-0">
                        <p className="text-[11px] text-gray-500 mb-1">Email</p>
                        <p className="text-sm font-semibold truncate">
                          {dataStudent.parentData.email || "Non renseigné"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Informations supplémentaires */}
                <div
                  className={`rounded-xl border overflow-hidden ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  <div
                    className={`px-5 py-4 border-b ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        <i className="fas fa-address-card text-sm" />
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Informations supplémentaires
                        </h3>
                        <p className="text-[11px] text-gray-500 mt-0.5">
                          Profession et adresse du responsable
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-x-8">
                    {[
                      {
                        label: "Profession",
                        icon: "fa-briefcase",
                        value:
                          capitalizeFirstLetter(
                            dataStudent.parentData.profession,
                          ) || "Non renseigné",
                      },
                      {
                        label: "Ville",
                        icon: "fa-city",
                        value:
                          capitalizeFirstLetter(dataStudent.parentData.ville) ||
                          "Non renseigné",
                      },
                      {
                        label: "Quartier",
                        icon: "fa-map-marked-alt",
                        value:
                          capitalizeFirstLetter(
                            dataStudent.parentData.quartier,
                          ) || "Non renseigné",
                      },
                      {
                        label: "Avenue",
                        icon: "fa-road",
                        value:
                          capitalizeFirstLetter(
                            dataStudent.parentData.avenue,
                          ) || "Non renseigné",
                      },
                    ].map((item, index) => (
                      <div
                        key={item.label}
                        className={`flex gap-3 py-4 ${
                          index < 2
                            ? `border-b ${
                                isDarkMode
                                  ? "border-[#21262D]"
                                  : "border-gray-100"
                              }`
                            : ""
                        }`}
                      >
                        <div
                          className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                            isDarkMode
                              ? "bg-gray-800 text-gray-400"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <i className={`fas ${item.icon} text-xs`} />
                        </div>

                        <div>
                          <p className="text-[11px] text-gray-500 mb-1">
                            {item.label}
                          </p>
                          <p className="text-sm font-semibold">{item.value}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Ponctualités */}
            {activeTab === "absences" && (
              <div>
                <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 lg:gap-4 mb-5">
                  {/* Présences */}
                  <div
                    className={`relative rounded-xl border p-4 overflow-hidden ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between mb-5">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-calendar-check text-sm" />
                      </div>

                      <span
                        className={`text-[10px] px-2 py-1 rounded-full ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        Présence
                      </span>
                    </div>

                    <p className="text-2xl lg:text-[28px] font-bold leading-none">
                      {presenceArr?.length || 0}
                    </p>

                    <p className="text-[11px] text-gray-500 mt-2">
                      Jours de présence
                    </p>

                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-blue-500" />
                  </div>

                  {/* Absences */}
                  <div
                    className={`relative rounded-xl border p-4 overflow-hidden ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between mb-5">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-red-500/10 text-red-400"
                            : "bg-red-50 text-red-500"
                        }`}
                      >
                        <i className="fas fa-calendar-times text-sm" />
                      </div>

                      <span className="text-[10px] px-2 py-1 rounded-full bg-red-500/10 text-red-500">
                        Absence
                      </span>
                    </div>

                    <p className="text-2xl lg:text-[28px] font-bold leading-none">
                      {absenceArr?.length || 0}
                    </p>

                    <p className="text-[11px] text-gray-500 mt-2">
                      Jours d'absence
                    </p>

                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-red-500" />
                  </div>

                  {/* Retards */}
                  <div
                    className={`relative rounded-xl border p-4 overflow-hidden ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between mb-5">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-amber-500/10 text-amber-400"
                            : "bg-amber-50 text-amber-500"
                        }`}
                      >
                        <i className="fas fa-clock text-sm" />
                      </div>

                      <span className="text-[10px] px-2 py-1 rounded-full bg-amber-500/10 text-amber-500">
                        Retard
                      </span>
                    </div>

                    <p className="text-2xl lg:text-[28px] font-bold leading-none">
                      {retardArr?.length || 0}
                    </p>

                    <p className="text-[11px] text-gray-500 mt-2">
                      Jours de retard
                    </p>

                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-amber-500" />
                  </div>

                  {/* Taux */}
                  <div
                    className={`relative rounded-xl border p-4 overflow-hidden ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between mb-5">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        <i className="fas fa-chart-line text-sm" />
                      </div>

                      <span className="text-[10px] px-2 py-1 rounded-full bg-emerald-500/10 text-emerald-500">
                        Taux
                      </span>
                    </div>

                    <p className="text-2xl lg:text-[28px] font-bold leading-none">
                      {presenceRate}%
                    </p>

                    <p className="text-[11px] text-gray-500 mt-2">
                      Taux de présence
                    </p>

                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-emerald-500" />
                  </div>
                </div>
                <div
                  className={`rounded-xl border mb-12 overflow-hidden ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  <div
                    className={`px-4 py-3 ${
                      isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                    } border-b ${
                      isDarkMode ? "border-gray-700" : "border-gray-200"
                    } flex flex-row justify-between items-center`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-amber-500/10 text-amber-400"
                            : "bg-amber-50 text-amber-600"
                        }`}
                      >
                        <i className="fas fa-history text-sm" />
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Historique des présences
                        </h3>

                        <p className="hidden sm:block text-[11px] text-gray-500 mt-0.5">
                          Présences, retards et absences enregistrés
                        </p>
                      </div>
                    </div>

                    {/* <div className="flex space-x-2"> */}
                    <div className="relative">
                      <button
                        onClick={toggleStatusDropdown}
                        className={`h-9 px-3 rounded-lg border flex items-center gap-2
                            text-xs font-medium transition-colors ${
                              isDarkMode
                                ? "bg-[#0D1117] border-[#30363D] hover:bg-[#21262D] text-gray-300"
                                : "bg-white border-gray-200 hover:bg-gray-50 text-gray-600"
                            }`}
                      >
                        <i className="fas fa-filter mr-2"></i>

                        <span className="hidden lg:flex text-xs">
                          {selectedStatusAttendance === 1
                            ? "Présences"
                            : selectedStatusAttendance === 2
                              ? "Retards"
                              : selectedStatusAttendance === 3
                                ? "Absences"
                                : "Tous les statuts"}
                        </span>
                      </button>
                      {isStatusDropdownOpen && (
                        <div
                          className={`absolute z-50 top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                            isDarkMode ? "bg-[#161B22]" : "bg-white"
                          } z-10 border ${
                            isDarkMode ? "border-gray-700" : "border-gray-300"
                          }`}
                        >
                          <div className="py-1">
                            <button
                              onClick={() => {
                                setSelectedStatusAttendance("Tous les statuts");
                                setIsStatusDropdownOpen(false);
                              }}
                              className={`block px-4 py-2 text-xs w-full text-left ${
                                isDarkMode
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-100"
                              } !rounded-button whitespace-nowrap`}
                            >
                              Tous les statuts
                            </button>
                            <button
                              onClick={() => {
                                setSelectedStatusAttendance(1);
                                setIsStatusDropdownOpen(false);
                              }}
                              className={`block px-4 py-2 text-xs w-full text-left ${
                                isDarkMode
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-100"
                              } !rounded-button whitespace-nowrap`}
                            >
                              Présences
                            </button>
                            <button
                              onClick={() => {
                                setSelectedStatusAttendance(2);
                                setIsStatusDropdownOpen(false);
                              }}
                              className={`block px-4 py-2 text-xs w-full text-left ${
                                isDarkMode
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-100"
                              } !rounded-button whitespace-nowrap`}
                            >
                              Retards
                            </button>
                            <button
                              onClick={() => {
                                setSelectedStatusAttendance(3);
                                setIsStatusDropdownOpen(false);
                              }}
                              className={`block px-4 py-2 text-xs w-full text-left ${
                                isDarkMode
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-100"
                              } !rounded-button whitespace-nowrap`}
                            >
                              Absences
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    {isAbsenceModalOpen && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center">
                        <div
                          className="absolute inset-0 bg-black bg-opacity-50"
                          onClick={() => setIsAbsenceModalOpen(false)}
                        ></div>
                        <div
                          className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
                            isDarkMode ? "bg-[#161B22]" : "bg-white"
                          }`}
                        >
                          <h3 className="text-xl font-semibold mb-4">
                            {"Modifier l'absence"}
                          </h3>
                          <div>
                            <div className="mb-4">
                              <label
                                className={`block text-sm font-medium mb-1 ${
                                  isDarkMode ? "text-gray-300" : "text-gray-700"
                                }`}
                              >
                                Statut
                              </label>
                              <div className="grid grid-cols-3 gap-2">
                                <button
                                  type="button"
                                  disabled={mutationUpdateAttendance.isPending}
                                  onClick={() => {
                                    SetCurrentAttendanceCoteId(1);
                                    setAbsenceForm((prev) => ({
                                      ...prev,
                                      status: "present",
                                    }));
                                  }}
                                  className={`p-2 rounded-md flex flex-col items-center ${
                                    mutationUpdateAttendance.isPending &&
                                    "cursor-not-allowed"
                                  }  ${
                                    absenceForm.status === "present"
                                      ? "bg-green-600 text-white"
                                      : isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-100 hover:bg-gray-200"
                                  } !rounded-button whitespace-nowrap`}
                                >
                                  <i className="fas fa-check-circle mb-1"></i>
                                  <span className="text-sm">Présent</span>
                                </button>
                                <button
                                  type="button"
                                  disabled={mutationUpdateAttendance.isPending}
                                  onClick={() => {
                                    SetCurrentAttendanceCoteId(2);
                                    setAbsenceForm((prev) => ({
                                      ...prev,
                                      status: "late",
                                    }));
                                  }}
                                  className={`p-2 rounded-md flex flex-col items-center ${
                                    mutationUpdateAttendance.isPending &&
                                    "cursor-not-allowed"
                                  } ${
                                    absenceForm.status === "late"
                                      ? "bg-yellow-600 text-white"
                                      : isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-100 hover:bg-gray-200"
                                  } !rounded-button whitespace-nowrap`}
                                >
                                  <i className="fas fa-clock mb-1"></i>
                                  <span className="text-sm">En retard</span>
                                </button>
                                <button
                                  type="button"
                                  disabled={mutationUpdateAttendance.isPending}
                                  onClick={() => {
                                    SetCurrentAttendanceCoteId(3);
                                    setAbsenceForm((prev) => ({
                                      ...prev,
                                      status: "absent",
                                    }));
                                  }}
                                  className={`p-2 rounded-md flex flex-col items-center ${
                                    mutationUpdateAttendance.isPending &&
                                    "cursor-not-allowed"
                                  } ${
                                    absenceForm.status === "absent"
                                      ? "bg-red-600 text-white"
                                      : isDarkMode
                                        ? "bg-gray-700 hover:bg-gray-600"
                                        : "bg-gray-100 hover:bg-gray-200"
                                  } !rounded-button whitespace-nowrap`}
                                >
                                  <i className="fas fa-times-circle mb-1"></i>
                                  <span className="text-sm">Absent</span>
                                </button>
                              </div>
                            </div>
                            {(absenceForm.status === "late" ||
                              absenceForm.status === "absent") && (
                              <>
                                <div className="mb-4">
                                  <label
                                    className={`block text-sm font-medium mb-1 ${
                                      isDarkMode
                                        ? "text-gray-300"
                                        : "text-gray-700"
                                    }`}
                                  >
                                    Motif de justification
                                  </label>

                                  <select
                                    disabled={
                                      mutationUpdateAttendance.isPending
                                    }
                                    value={absenceForm.reason}
                                    onChange={(e) =>
                                      setAbsenceForm((prev) => ({
                                        ...prev,
                                        reason: e.target.value,
                                      }))
                                    }
                                    className={`w-full px-3 py-1 rounded-md border ${
                                      isDarkMode
                                        ? "bg-[#0D1117] border-gray-700 text-white"
                                        : "bg-white border-gray-300"
                                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                    required
                                  >
                                    <option value="">
                                      Sélectionner un motif
                                    </option>
                                    <option value="Maladie">Maladie</option>
                                    <option value="Rendez-vous médical">
                                      Rendez-vous médical
                                    </option>
                                    <option value="Problème familial">
                                      Problème familial
                                    </option>
                                    <option value="Transport">
                                      Problème de transport
                                    </option>

                                    <option value="Autre">Autre</option>
                                  </select>

                                  {/* <textarea
                                disabled={mutationFn.isPending}
                                value={absenceForm.reason}
                                onChange={(e) =>
                                  setAbsenceForm((prev) => ({
                                    ...prev,
                                    reason: e.target.value,
                                  }))
                                }
                                rows={3}
                                className={`w-full px-3 py-2 rounded-md border ${
                                  mutationFn.isPending && "cursor-not-allowed"
                                } ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700 text-white"
                                    : "bg-white border-gray-300"
                                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                required
                              ></textarea> */}
                                </div>
                                {/* <div className="mb-4">
                              <label className="flex items-center">
                                <input
                                  type="checkbox"
                                  checked={absenceForm.justified}
                                  onChange={(e) =>
                                    setAbsenceForm((prev) => ({
                                      ...prev,
                                      justified: e.target.checked,
                                    }))
                                  }
                                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                />
                                <span
                                  className={`ml-2 text-sm ${
                                    isDarkMode
                                      ? "text-gray-300"
                                      : "text-gray-700"
                                  }`}
                                >
                                  {absenceForm.status === "late"
                                    ? "Retard justifié"
                                    : "Absence justifiée"}
                                </span>
                              </label>
                            </div> */}
                              </>
                            )}
                            <div className="flex justify-end space-x-3">
                              <button
                                type="button"
                                disabled={mutationUpdateAttendance.isPending}
                                onClick={() => {
                                  setIsAbsenceModalOpen(false);
                                  SetCurrentAttendanceCoteId(null);
                                  SetCurrentAttendanceId(null);
                                  setAbsenceForm((prev) => ({
                                    ...prev,
                                    isEditing: false,
                                  }));
                                }}
                                className={`px-4 py-2 rounded-md ${
                                  mutationUpdateAttendance.isPending &&
                                  "cursor-not-allowed"
                                } ${
                                  isDarkMode
                                    ? "bg-gray-700 hover:bg-gray-600"
                                    : "bg-gray-200 hover:bg-gray-300"
                                } !rounded-button whitespace-nowrap`}
                              >
                                Annuler
                              </button>
                              <button
                                disabled={mutationUpdateAttendance.isPending}
                                onClick={() => {
                                  handleUpdateAttendance();
                                }}
                                className={`px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white !rounded-button whitespace-nowrap`}
                              >
                                {mutationUpdateAttendance.isPending
                                  ? "Chargement..."
                                  : "Mettre à jour"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-700">
                      <thead
                        className={isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}
                      >
                        <tr>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Date
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Cotation
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Justification
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Statut
                          </th>
                          <HasRole
                            allowedRoles={[
                              "SuperAdministrateur",
                              "Administrateur",
                              "Comptable",
                            ]}
                          >
                            <th
                              scope="col"
                              className={`px-5 py-3 text-center text-[10px] font-semibold uppercase tracking-wider ${
                                isDarkMode ? "text-gray-500" : "text-gray-400"
                              }`}
                            >
                              Actions
                            </th>
                          </HasRole>
                        </tr>
                      </thead>
                      <tbody
                        className={`${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } divide-y ${
                          isDarkMode ? "divide-gray-700" : "divide-gray-200"
                        }`}
                      >
                        {filteredAttendanceList &&
                        filteredAttendanceList.length > 0 ? (
                          filteredAttendanceList.map((item, index) => {
                            let date, cote, motif, justifie;
                            date = moment(item.created_at).format("DD/MM/YYYY");
                            cote = item.cote_eleve_id;
                            // status =
                            //   item.cote_eleve_id === 2 ? "late" : "absent";
                            justifie = item.justification ? true : false;
                            motif = item.justification
                              ? item.justification
                              : null;

                            return (
                              <tr
                                key={index}
                                className={`transition-colors ${
                                  isDarkMode
                                    ? "hover:bg-[#161B22]"
                                    : "hover:bg-gray-50"
                                }`}
                              >
                                <td className="px-5 py-3.5 whitespace-nowrap">
                                  <div
                                    className={`font-medium ${
                                      isDarkMode
                                        ? "text-gray-300"
                                        : "text-gray-700"
                                    }`}
                                  >
                                    {date}
                                  </div>
                                </td>

                                <td className="px-5 py-3.5 text-left whitespace-nowrap">
                                  <div className="flex justify-center space-x-2">
                                    <button
                                      className={`p-2 rounded-full ${
                                        cote === 3
                                          ? "bg-red-500 text-white"
                                          : isDarkMode
                                            ? "bg-gray-700 text-gray-300"
                                            : "bg-gray-200 text-gray-600"
                                      }`}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                    <button
                                      className={`p-2 rounded-full ${
                                        cote === 2
                                          ? "bg-yellow-500 text-white"
                                          : isDarkMode
                                            ? "bg-gray-700 text-gray-300"
                                            : "bg-gray-200 text-gray-600"
                                      }`}
                                    >
                                      <i className="fas fa-clock"></i>
                                    </button>
                                  </div>
                                </td>

                                <td className="hidden lg:flex px-5 py-3.5 whitespace-nowrap text-center">
                                  {motif || "-"}
                                </td>

                                <td className="px-5 py-3.5 whitespace-nowrap text-center">
                                  <span
                                    className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                      justifie
                                        ? "bg-green-100 text-green-800"
                                        : "bg-red-100 text-red-800"
                                    }`}
                                  >
                                    {justifie ? "Justifiée" : "Non justifiée"}
                                  </span>
                                </td>
                                {/* <HasRole
                                  allowedRoles={[
                                    "SuperAdministrateur",
                                    "Administrateur",
                                    "Comptable",
                                  ]}
                                > */}
                                <td className="px-5 py-3.5 whitespace-nowrap text-center">
                                  <div className="flex justify-center space-x-3">
                                    <button className="text-green-500 hover:text-green-700">
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button className="text-red-300 cursor-not-allowed">
                                      <i className="fas fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </td>
                                {/* </HasRole> */}
                              </tr>
                            );
                          })
                        ) : (
                          <tr
                            className={`transition-colors ${
                              isDarkMode
                                ? "hover:bg-[#161B22]"
                                : "hover:bg-gray-50"
                            }`}
                          >
                            <td
                              colSpan={5}
                              className={`px-5 py-3.5 text-center text-xs font-medium ${
                                isDarkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                            >
                              <span className="text-slate-500 text-xs">
                                Aucune paiement disponible
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {/* Paiements */}
            {activeTab === "paiements" && (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
                  {/* Total payé */}
                  <div
                    className={`rounded-xl border p-5 ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-[11px] font-medium text-gray-500">
                          Total payé
                        </p>

                        <p className="text-2xl font-bold mt-1">
                          {`${getPaymentAmount().paid.toFixed(2)}` || 0} $
                        </p>
                      </div>

                      <div
                        className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        <i className="fas fa-wallet" />
                      </div>
                    </div>

                    <div className="mt-6">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-[10px] text-gray-500">
                          Progression
                        </span>

                        <span className="text-[11px] font-bold text-emerald-500">
                          {getPaymentAmount().percentage}%
                        </span>
                      </div>

                      <div
                        className={`h-1.5 rounded-full overflow-hidden ${
                          isDarkMode ? "bg-[#21262D]" : "bg-gray-100"
                        }`}
                      >
                        <div
                          className="h-full bg-emerald-500 rounded-full transition-all duration-500"
                          style={{
                            width: `${
                              (getPaymentAmount().paid * 100) /
                              getPaymentAmount().total
                            }%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Solde restant */}
                  <div
                    className={`rounded-xl border p-5 ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-[11px] font-medium text-gray-500">
                          Solde restant
                        </p>

                        <p className="text-2xl font-bold mt-1">
                          {`${getPaymentAmount().balance.toFixed(2)}` || 0} $
                        </p>
                      </div>

                      <div
                        className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-amber-500/10 text-amber-400"
                            : "bg-amber-50 text-amber-600"
                        }`}
                      >
                        <i className="fas fa-hourglass-half" />
                      </div>
                    </div>

                    <div
                      className={`mt-5 p-3 rounded-lg flex items-center gap-2 ${
                        isDarkMode
                          ? "bg-amber-500/5 border border-amber-500/20"
                          : "bg-amber-50 border border-amber-100"
                      }`}
                    >
                      <i className="fas fa-calendar-alt text-amber-500 text-xs" />

                      <span className="text-[11px] font-medium">
                        {filteredPaiementsForStudent[0]
                          ? `Dernier paiement · ${moment(
                              filteredPaiementsForStudent[0].created_at,
                            ).format("DD/MM/YYYY")}`
                          : "Aucun paiement enregistré"}
                      </span>
                    </div>
                  </div>

                  {/* Total annuel */}
                  <div
                    className={`rounded-xl border p-5 ${
                      isDarkMode
                        ? "bg-[#0D1117] border-[#30363D]"
                        : "bg-white border-gray-200 shadow-sm"
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-[11px] font-medium text-gray-500">
                          Total annuel
                        </p>

                        <p className="text-2xl font-bold mt-1">
                          {`${getPaymentAmount().total.toFixed(2)}` || 0} $
                        </p>
                      </div>

                      <div
                        className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-coins" />
                      </div>
                    </div>

                    <div
                      className={`grid grid-cols-2 gap-3 mt-5 pt-4 border-t ${
                        isDarkMode ? "border-[#21262D]" : "border-gray-100"
                      }`}
                    >
                      <div>
                        <p className="text-[10px] text-gray-500">
                          Frais de scolarité
                        </p>

                        <p className="text-xs font-semibold mt-1">
                          {`${getPaymentAmount().total.toFixed(2)}` || 0} $
                        </p>
                      </div>

                      <div>
                        <p className="text-[10px] text-gray-500">
                          Frais connexes
                        </p>

                        <p className="text-xs font-semibold mt-1">0.00 $</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`rounded-lg border mb-12 max-w-[445px] sm:max-w-[500px] md:max-w-[535px] lg:max-w-full ${
                    isDarkMode ? "border-gray-700" : "border-gray-200"
                  } overflow-hidden`}
                >
                  <div
                    className={`px-5 py-4 border-b flex justify-between items-center gap-4 ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        <i className="fas fa-receipt text-sm" />
                      </div>

                      <div>
                        <h3 className="text-sm font-semibold">
                          Historique des paiements
                        </h3>

                        <p className="hidden sm:block text-[11px] text-gray-500 mt-0.5">
                          Transactions effectuées par cet élève
                        </p>
                      </div>
                    </div>
                    <HasRole
                      allowedRoles={[
                        "SuperAdministrateur",
                        "Administrateur",
                        "Comptable",
                      ]}
                    >
                      <div className="flex items-center space-x-2">
                        <button
                          id="newPaymentBtn"
                          onClick={() => {
                            setPaymentForm({
                              date: "",
                              amount: "",
                              type: paymentForm.type,
                              method: "Espèce",
                              status: paymentForm.status,
                              isEditing: false,
                              editingId: null,
                            });
                            setIsPaymentModalOpen(true);
                          }}
                          className={`flex items-center px-3 py-2 rounded-lg text-sm ${
                            isDarkMode
                              ? "bg-blue-600 hover:bg-blue-700"
                              : "bg-blue-500 hover:bg-blue-600"
                          } text-white !rounded-button whitespace-nowrap`}
                        >
                          <i className="fas fa-plus mr-1"></i>
                          <span className="hidden lg:flex text-xs font-semibold">
                            Nouveau paiement
                          </span>
                        </button>
                        {isPaymentModalOpen && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
                            {/* Overlay */}
                            <div
                              className="absolute inset-0"
                              onClick={() => setIsPaymentModalOpen(false)}
                            />

                            {/* Modal */}
                            <div
                              className={`relative w-full max-w-lg overflow-hidden rounded-2xl border shadow-2xl ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22]"
                                  : "border-gray-200 bg-white"
                              }`}
                            >
                              {/* ================= HEADER ================= */}
                              <div
                                className={`flex items-center justify-between gap-4 border-b px-5 py-4 sm:px-6 ${
                                  isDarkMode
                                    ? "border-[#30363D]"
                                    : "border-gray-200"
                                }`}
                              >
                                <div className="flex items-center gap-3">
                                  <div
                                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                                      isDarkMode
                                        ? "bg-blue-500/10 text-blue-400"
                                        : "bg-blue-50 text-blue-600"
                                    }`}
                                  >
                                    <i className="fas fa-cash-register text-sm" />
                                  </div>

                                  <div>
                                    <h3
                                      className={`text-sm font-semibold sm:text-base ${
                                        isDarkMode
                                          ? "text-gray-100"
                                          : "text-gray-900"
                                      }`}
                                    >
                                      Nouveau paiement
                                    </h3>

                                    <p
                                      className={`mt-0.5 text-[10px] sm:text-[11px] ${
                                        isDarkMode
                                          ? "text-gray-500"
                                          : "text-gray-500"
                                      }`}
                                    >
                                      Enregistrez un nouveau paiement pour cet
                                      élève
                                    </p>
                                  </div>
                                </div>

                                {/* Fermer */}
                                <button
                                  type="button"
                                  onClick={() => setIsPaymentModalOpen(false)}
                                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border transition-colors ${
                                    isDarkMode
                                      ? "border-[#30363D] text-gray-400 hover:bg-[#21262D] hover:text-white"
                                      : "border-gray-200 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                                  }`}
                                  title="Fermer"
                                >
                                  <i className="fas fa-times text-xs" />
                                </button>
                              </div>

                              {/* ================= CONTENT ================= */}
                              <div className="p-5 sm:p-6">
                                <div className="space-y-5">
                                  {/* ================= TYPE DE FRAIS ================= */}
                                  <div>
                                    <div className="mb-2 flex items-center gap-2">
                                      <div
                                        className={`flex h-7 w-7 items-center justify-center rounded-lg ${
                                          isDarkMode
                                            ? "bg-blue-500/10 text-blue-400"
                                            : "bg-blue-50 text-blue-600"
                                        }`}
                                      >
                                        <i className="fas fa-file-invoice-dollar text-[10px]" />
                                      </div>

                                      <label
                                        className={`text-[11px] font-semibold ${
                                          isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                        }`}
                                      >
                                        Type de frais
                                      </label>

                                      <span className="text-red-500">*</span>
                                    </div>

                                    <div
                                      className={`relative overflow-hidden rounded-xl border transition-colors focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/10 ${
                                        isDarkMode
                                          ? "border-[#30363D] bg-[#0D1117]"
                                          : "border-gray-200 bg-white"
                                      }`}
                                    >
                                      {/* Icon */}
                                      <div
                                        className={`pointer-events-none absolute inset-y-0 left-0 flex w-11 items-center justify-center border-r ${
                                          isDarkMode
                                            ? "border-[#30363D] text-blue-400"
                                            : "border-gray-200 text-blue-500"
                                        }`}
                                      >
                                        <i className="fas fa-receipt text-[10px]" />
                                      </div>

                                      <select
                                        value={paymentForm.type}
                                        onChange={(e) =>
                                          setPaymentForm((prev) => ({
                                            ...prev,
                                            type: e.target.value,
                                          }))
                                        }
                                        className={`h-11 w-full appearance-none bg-transparent pl-14 pr-10 text-xs outline-none ${
                                          isDarkMode
                                            ? "text-gray-200"
                                            : "text-gray-700"
                                        }`}
                                        required
                                      >
                                        <option value={1} defaultChecked>
                                          Frais de scolarité
                                        </option>
                                      </select>

                                      {/* Chevron */}
                                      <div className="pointer-events-none absolute inset-y-0 right-0 flex w-10 items-center justify-center text-gray-500">
                                        <i className="fas fa-chevron-down text-[9px]" />
                                      </div>
                                    </div>
                                  </div>

                                  {/* ================= MONTANT ================= */}
                                  <div>
                                    <div className="mb-2 flex items-center gap-2">
                                      <div
                                        className={`flex h-7 w-7 items-center justify-center rounded-lg ${
                                          isDarkMode
                                            ? "bg-emerald-500/10 text-emerald-400"
                                            : "bg-emerald-50 text-emerald-600"
                                        }`}
                                      >
                                        <i className="fas fa-dollar-sign text-[10px]" />
                                      </div>

                                      <label
                                        className={`text-[11px] font-semibold ${
                                          isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                        }`}
                                      >
                                        Montant ($)
                                      </label>

                                      <span className="text-red-500">*</span>
                                    </div>

                                    <div
                                      className={`relative overflow-hidden rounded-xl border transition-colors focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/10 ${
                                        isDarkMode
                                          ? "border-[#30363D] bg-[#0D1117]"
                                          : "border-gray-200 bg-white"
                                      }`}
                                    >
                                      {/* Dollar */}
                                      <div
                                        className={`pointer-events-none absolute inset-y-0 left-0 flex w-11 items-center justify-center border-r text-sm font-semibold ${
                                          isDarkMode
                                            ? "border-[#30363D] text-emerald-400"
                                            : "border-gray-200 text-emerald-600"
                                        }`}
                                      >
                                        $
                                      </div>

                                      <input
                                        type="number"
                                        value={paymentForm.amount}
                                        onChange={(e) =>
                                          setPaymentForm((prev) => ({
                                            ...prev,
                                            amount: Number(e.target.value),
                                          }))
                                        }
                                        className={`h-11 w-full bg-transparent pl-14 pr-4 text-sm font-semibold outline-none ${
                                          isDarkMode
                                            ? "text-gray-100 placeholder:text-gray-600"
                                            : "text-gray-800 placeholder:text-gray-400"
                                        }`}
                                        placeholder="0,00"
                                        required
                                        min="0"
                                        step="0.01"
                                      />
                                    </div>
                                  </div>

                                  {/* ================= INFORMATION ================= */}
                                  <div
                                    className={`flex items-start gap-3 rounded-xl border p-3.5 ${
                                      isDarkMode
                                        ? "border-blue-500/20 bg-blue-500/[0.05]"
                                        : "border-blue-100 bg-blue-50/60"
                                    }`}
                                  >
                                    <div
                                      className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${
                                        isDarkMode
                                          ? "bg-blue-500/10 text-blue-400"
                                          : "bg-blue-100 text-blue-600"
                                      }`}
                                    >
                                      <i className="fas fa-info text-[10px]" />
                                    </div>

                                    <div>
                                      <p
                                        className={`text-[11px] font-semibold ${
                                          isDarkMode
                                            ? "text-blue-300"
                                            : "text-blue-700"
                                        }`}
                                      >
                                        Information importante
                                      </p>

                                      <p
                                        className={`mt-1 text-[10px] leading-relaxed ${
                                          isDarkMode
                                            ? "text-gray-400"
                                            : "text-gray-500"
                                        }`}
                                      >
                                        Le montant à payer ne doit pas dépasser
                                        le solde restant de l'élève.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* ================= FOOTER ================= */}
                              <div
                                className={`flex flex-col-reverse gap-2 border-t px-5 py-4 sm:flex-row sm:items-center sm:justify-end sm:px-6 ${
                                  isDarkMode
                                    ? "border-[#30363D] bg-[#0D1117]/40"
                                    : "border-gray-200 bg-gray-50/70"
                                }`}
                              >
                                {/* ANNULER */}
                                <button
                                  type="button"
                                  disabled={
                                    mutationCreatePayment.isPending ||
                                    mutationUpdatePayment.isPending
                                  }
                                  onClick={() => setIsPaymentModalOpen(false)}
                                  className={`flex h-10 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition-colors ${
                                    isDarkMode
                                      ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                                      : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                                  } ${
                                    (mutationCreatePayment.isPending ||
                                      mutationUpdatePayment.isPending) &&
                                    "cursor-not-allowed opacity-50"
                                  }`}
                                >
                                  <i className="fas fa-times text-[9px]" />
                                  Annuler
                                </button>

                                {/* ENREGISTRER */}
                                <button
                                  onClick={() => {
                                    if (!paymentForm.amount)
                                      return showNotification(
                                        "Le montant à payer ne doit pas être nul s'il vous plait",
                                        "error",
                                      );

                                    setPassword("");

                                    if (
                                      paymentForm.amount >
                                      getPaymentAmount().balance
                                    )
                                      return showNotification(
                                        "Le montant à payer ne doit pas dépasser le solde restant",
                                        "error",
                                      );

                                    setIsPaymentModalOpen(false);
                                    setPendingPaiementAction("create");
                                  }}
                                  className="flex h-10 items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-blue-700"
                                >
                                  <i className="fas fa-save text-[10px]" />
                                  Enregistrer le paiement
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </HasRole>
                  </div>
                  <div className="overflow-x-auto ">
                    <table className="min-w-full divide-y divide-gray-700">
                      <thead
                        className={isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}
                      >
                        <tr>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Date
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Montant
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Type
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-left text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Année scolaire
                          </th>
                          <th
                            scope="col"
                            className={`px-5 py-3 text-center text-[10px] font-semibold uppercase tracking-wider ${
                              isDarkMode ? "text-gray-500" : "text-gray-400"
                            }`}
                          >
                            Statut
                          </th>
                          <HasRole
                            allowedRoles={[
                              "SuperAdministrateur",
                              "Administrateur",
                              "Comptable",
                            ]}
                          >
                            <th
                              scope="col"
                              className={`px-5 py-3 text-center text-[10px] font-semibold uppercase tracking-wider ${
                                isDarkMode ? "text-gray-500" : "text-gray-400"
                              }`}
                            >
                              Actions
                            </th>
                          </HasRole>
                        </tr>
                      </thead>
                      <tbody
                        className={`${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } divide-y ${
                          isDarkMode ? "divide-gray-700" : "divide-gray-200"
                        }`}
                      >
                        {filteredPaiementsForStudent &&
                        filteredPaiementsForStudent.length > 0 ? (
                          filteredPaiementsForStudent.map((paiement, index) => {
                            // console.log(paiement);
                            let motif: string = "",
                              motifId: any;

                            for (let element of motifPaiementArr) {
                              if (paiement.motif_paiement_id === element.id) {
                                motif = element.designation;
                                motifId = element.id;
                              }
                            }

                            return (
                              <tr
                                key={index}
                                className={`transition-colors ${
                                  isDarkMode
                                    ? "hover:bg-[#161B22]"
                                    : "hover:bg-gray-50"
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const receiptData = {
                                    id: `INV-${new Date().getFullYear()}-${String(
                                      index + 1,
                                    ).padStart(4, "0")}`,
                                    date: paiement.created_at,
                                    amount: paiement.montant,
                                    type: motifId,
                                    method: "Espèce",
                                    status: paiement.status,
                                    student: dataStudent.nom,
                                    class: dataStudent.classeDesignation,
                                    annee_scolaire_designation:
                                      paiement.annee_scolaire_designation,
                                  };
                                  setReceiptData(receiptData);
                                  setIsReceiptModalOpen(true);
                                }}
                              >
                                <td className="px-5 py-3.5 whitespace-nowrap text-xs">
                                  <div
                                    className={`font-medium ${
                                      isDarkMode
                                        ? "text-gray-300"
                                        : "text-gray-700"
                                    }`}
                                  >
                                    {moment(paiement.created_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </div>
                                </td>
                                <td className="px-5 py-3.5 whitespace-nowrap text-xs font-medium">
                                  {paiement.montant} $
                                </td>
                                <td className="px-5 py-3.5 whitespace-nowrap text-xs">
                                  {motif}
                                </td>
                                <td className="px-5 py-3.5 whitespace-nowrap text-xs">
                                  {paiement.annee_scolaire_designation}
                                </td>
                                <td className="px-5 py-3.5 whitespace-nowrap align-right text-center text-xs">
                                  <span
                                    className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-semibold rounded-full ${
                                      paiement.status === 1
                                        ? isDarkMode
                                          ? "bg-green-500/10 text-green-400"
                                          : "bg-green-100 text-green-800"
                                        : isDarkMode
                                          ? "bg-red-500/10 text-red-400"
                                          : "bg-red-100 text-red-800"
                                    }`}
                                  >
                                    <span
                                      className={`h-1.5 w-1.5 rounded-full ${
                                        paiement.status === 1
                                          ? "bg-green-500"
                                          : "bg-red-500"
                                      }`}
                                    ></span>
                                    {paiement.status === 1 ? "Payé" : "Annulé"}
                                  </span>
                                </td>

                                <HasRole
                                  allowedRoles={[
                                    "SuperAdministrateur",
                                    "Administrateur",
                                    "Comptable",
                                  ]}
                                >
                                  <td
                                    className="px-5 py-3.5 whitespace-nowrap text-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    <div className="flex justify-center space-x-3">
                                      <button
                                        id={`receiptBtn-${index}`}
                                        onClick={() => {
                                          const receiptData = {
                                            id: `INV-${new Date().getFullYear()}-${String(
                                              index + 1,
                                            ).padStart(4, "0")}`,
                                            date: paiement.created_at,
                                            amount: paiement.montant,
                                            type: motifId,
                                            method: "Espèce",
                                            status: paiement.status,
                                            student: dataStudent.nom,
                                            class:
                                              dataStudent.classeDesignation,
                                            annee_scolaire_designation:
                                              paiement.annee_scolaire_designation,
                                          };
                                          setReceiptData(receiptData);
                                          setIsReceiptModalOpen(true);
                                        }}
                                        className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                                      >
                                        <i className="fas fa-receipt"></i>
                                      </button>

                                      <button
                                        disabled={!paiement.status}
                                        onClick={() => {
                                          setCurrentPaiementId(paiement.id);
                                          setPaymentForm({
                                            date: "",
                                            amount: paiement.montant,
                                            type: "",
                                            method: "Espèce",
                                            status: 1,
                                            isEditing: false,
                                            editingId: null,
                                          });
                                          setShowCancelModal(true);
                                        }}
                                        className={`${
                                          !paiement.status
                                            ? "text-gray-400 cursor-not-allowed"
                                            : "text-red-500 hover:text-red-700 cursor-pointer"
                                        }  !rounded-button whitespace-nowrap`}
                                        title="Annuler"
                                      >
                                        <i className="fas fa-trash-alt"></i>
                                      </button>
                                    </div>
                                  </td>
                                </HasRole>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className={`px-5 py-3.5 text-center text-xs font-medium ${
                                isDarkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                            >
                              <span className="text-slate-500 text-xs">
                                Aucune paiement disponible
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "messages" && (
              <div>
                <div
                  className={`rounded-xl border overflow-hidden mb-6 ${
                    isDarkMode
                      ? "bg-[#0D1117] border-[#30363D]"
                      : "bg-white border-gray-200 shadow-sm"
                  }`}
                >
                  {/* Toolbar */}
                  <div
                    className={`p-4 border-b ${
                      isDarkMode
                        ? "bg-[#161B22] border-[#30363D]"
                        : "bg-gray-50/70 border-gray-200"
                    }`}
                  >
                    <div className="flex flex-col xl:flex-row xl:items-center gap-4">
                      {/* Categories */}
                      <div
                        className={`inline-flex p-1 rounded-lg self-start ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
                        }`}
                      >
                        {[
                          {
                            value: "Tous",
                            label: "Tous",
                            icon: "fa-inbox",
                          },
                          {
                            value: "Individuel",
                            label: "Messages",
                            icon: "fa-envelope",
                          },
                          {
                            value: "Groupe",
                            label: "Communiqués",
                            icon: "fa-bullhorn",
                          },
                        ].map((category) => (
                          <button
                            key={category.value}
                            onClick={() => setSelectedCategory(category.value)}
                            className={`px-3 py-2 rounded-md text-[11px] font-medium transition flex items-center gap-2 ${
                              selectedCategory === category.value
                                ? isDarkMode
                                  ? "bg-[#21262D] text-white shadow-sm"
                                  : "bg-white text-gray-900 shadow-sm"
                                : "text-gray-500 hover:text-gray-700"
                            }`}
                          >
                            <i className={`fas ${category.icon} text-[10px]`} />
                            {category.label}
                          </button>
                        ))}
                      </div>

                      {/* Search */}
                      <div className="flex flex-1 flex-col sm:flex-row gap-3 xl:justify-end">
                        <div className="relative flex-1 xl:max-w-sm">
                          <i className="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs" />

                          <input
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            type="text"
                            placeholder="Rechercher un message..."
                            className={`w-full h-9 pl-9 pr-3 rounded-lg border text-xs outline-none transition ${
                              isDarkMode
                                ? "bg-[#0D1117] border-[#30363D] focus:border-blue-500"
                                : "bg-white border-gray-200 focus:border-blue-500"
                            }`}
                          />
                        </div>

                        <div className="relative">
                          <i className="fas fa-filter absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-[10px]" />

                          <select
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                            className={`h-9 pl-8 pr-8 rounded-lg border text-xs outline-none ${
                              isDarkMode
                                ? "bg-[#0D1117] border-[#30363D] text-white"
                                : "bg-white border-gray-200"
                            }`}
                          >
                            <option value="Tous les types">
                              Tous les types
                            </option>
                            <option value="Email">Emails</option>
                            <option value="SMS">SMS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-y-auto max-h-[600px]">
                    {
                      filteredMessages.filter(
                        (item) =>
                          item.destinataires === "Parent" &&
                          item.Category === "Individuel" &&
                          item?.destinataire_id === dataStudent.parent_id,
                      ).length === 0 ? (
                        <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
                          <div
                            className={`mb-3 flex h-11 w-11 items-center justify-center rounded-xl ${
                              isDarkMode
                                ? "bg-[#161B22] text-gray-500"
                                : "bg-gray-100 text-gray-400"
                            }`}
                          >
                            <i className="fas fa-inbox text-sm" />
                          </div>

                          <p
                            className={`text-xs font-semibold ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Aucun message trouvé
                          </p>

                          <p className="mt-1 max-w-xs text-[10px] leading-relaxed text-gray-500">
                            Aucun message envoyé actuellement au parent d'élève.
                          </p>
                        </div>
                      ) : (
                        filteredMessages
                          .filter(
                            (item) =>
                              item.destinataires === "Parent" &&
                              item.Category === "Individuel" &&
                              item.destinataire_id === dataStudent.parent_id,
                          )
                          .map((communication, index) => {
                            return (
                              <div
                                key={index}
                                className={`group border-b p-4 transition-colors last:border-b-0 sm:p-5 ${
                                  isDarkMode
                                    ? "border-[#21262D] hover:bg-[#161B22]"
                                    : "border-gray-100 hover:bg-gray-50/70"
                                }`}
                              >
                                {/* ================= MESSAGE HEADER ================= */}
                                <div className="flex items-start gap-3">
                                  {/* Message icon */}
                                  <div
                                    className={`hidden h-9 w-9 shrink-0 items-center justify-center rounded-lg md:flex ${
                                      communication.Category === "Groupe"
                                        ? isDarkMode
                                          ? "bg-purple-500/10 text-purple-400"
                                          : "bg-purple-50 text-purple-600"
                                        : isDarkMode
                                          ? "bg-blue-500/10 text-blue-400"
                                          : "bg-blue-50 text-blue-600"
                                    }`}
                                  >
                                    <i
                                      className={`fas ${
                                        communication.Category === "Groupe"
                                          ? "fa-comments"
                                          : "fa-envelope"
                                      } text-[11px]`}
                                    />
                                  </div>

                                  {/* Message content */}
                                  <div className="min-w-0 flex-1">
                                    <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                                      <div className="min-w-0">
                                        {/* Title + status */}
                                        <div className="flex flex-wrap items-center gap-2">
                                          <p
                                            className={`truncate text-xs font-semibold sm:text-[13px] ${
                                              isDarkMode
                                                ? "text-gray-200"
                                                : "text-gray-800"
                                            }`}
                                          >
                                            {communication.type} -{" "}
                                            {communication.objet}
                                          </p>

                                          <span
                                            className={`inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-[9px] font-semibold ${
                                              isDarkMode
                                                ? "bg-emerald-500/10 text-emerald-400"
                                                : "bg-emerald-50 text-emerald-600"
                                            }`}
                                          >
                                            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                            Envoyé
                                          </span>
                                        </div>

                                        {/* Recipient */}
                                        <div className="mt-1.5 flex items-center gap-1.5">
                                          <i className="fas fa-user text-[8px] text-gray-500" />

                                          <p className="text-[10px] text-gray-500">
                                            À:{" "}
                                            <span
                                              className={
                                                isDarkMode
                                                  ? "text-gray-400"
                                                  : "text-gray-600"
                                              }
                                            >
                                              {communication.Category ===
                                                "Groupe" && "Tous les parents"}

                                              {communication.Category ===
                                                "Individuel" &&
                                                capitalizeFirstLetter(
                                                  dataStudent.parentData?.nom ||
                                                    "Inconnu",
                                                ) +
                                                  " " +
                                                  capitalizeFirstLetter(
                                                    dataStudent.parentData
                                                      ?.postnom || "",
                                                  ) +
                                                  " " +
                                                  capitalizeFirstLetter(
                                                    dataStudent.parentData
                                                      ?.prenom || "",
                                                  )}
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      {/* Communication type */}
                                      <div
                                        className={`hidden shrink-0 items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[9px] font-medium lg:flex ${
                                          isDarkMode
                                            ? "border-[#30363D] bg-[#0D1117] text-gray-400"
                                            : "border-gray-200 bg-white text-gray-500"
                                        }`}
                                      >
                                        <i
                                          className={`fas ${
                                            communication.type === "SMS"
                                              ? "fa-comment-sms"
                                              : "fa-envelope"
                                          } text-[8px]`}
                                        />

                                        {communication.type}
                                      </div>
                                    </div>

                                    {/* ================= MESSAGE BODY ================= */}
                                    <div
                                      className={`mt-3 rounded-lg border px-3.5 py-3 ${
                                        isDarkMode
                                          ? "border-[#21262D] bg-[#0D1117]/50"
                                          : "border-gray-100 bg-gray-50/60"
                                      }`}
                                    >
                                      <div className="mb-2 flex items-center gap-1.5">
                                        <span className="text-[9px] font-semibold uppercase tracking-wide text-gray-500">
                                          Objet:
                                        </span>

                                        <span
                                          className={`text-[10px] font-medium ${
                                            isDarkMode
                                              ? "text-gray-300"
                                              : "text-gray-700"
                                          }`}
                                        >
                                          {communication.objet}
                                        </span>
                                      </div>

                                      <p
                                        className={`text-[11px] leading-relaxed ${
                                          isDarkMode
                                            ? "text-gray-400"
                                            : "text-gray-600"
                                        }`}
                                      >
                                        {communication.contenu.length > 300
                                          ? communication.contenu.substring(
                                              0,
                                              300,
                                            ) + "..."
                                          : communication.contenu}
                                      </p>
                                    </div>

                                    {/* ================= MESSAGE FOOTER ================= */}
                                    <div
                                      className={`mt-3 flex flex-col gap-3 border-t pt-3 sm:flex-row sm:items-center sm:justify-between ${
                                        isDarkMode
                                          ? "border-[#21262D]"
                                          : "border-gray-100"
                                      }`}
                                    >
                                      {/* Date */}
                                      <div
                                        className={`flex items-center gap-2 text-[10px] ${
                                          isDarkMode
                                            ? "text-gray-500"
                                            : "text-gray-400"
                                        }`}
                                      >
                                        <i className="far fa-clock text-[9px]" />

                                        <span>
                                          {communication.date}{" "}
                                          {communication.heure}
                                        </span>
                                      </div>

                                      {/* Actions */}
                                      <div className="flex items-center gap-2">
                                        <button
                                          className={`flex h-8 items-center gap-2 rounded-lg border px-3 text-[10px] font-medium transition-colors ${
                                            isDarkMode
                                              ? "border-blue-500/20 bg-blue-500/10 text-blue-400 hover:bg-blue-500/20"
                                              : "border-blue-100 bg-blue-50 text-blue-600 hover:bg-blue-100"
                                          }`}
                                          onClick={() => {
                                            setcreateMessageForm({
                                              objet: communication.objet,
                                              contenu: communication.contenu,
                                              destinateur_id:
                                                dataStudent?.parent_id || null,
                                              annee_scolaire_id: "",
                                              canal: "email",
                                              status: 0,
                                            });

                                            setIsContactModalOpen(true);
                                          }}
                                        >
                                          <i className="fas fa-forward text-[9px]" />
                                          <span>Renvoyer</span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) /* ================= EMPTY STATE ================= */
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Receipt Modal */}
      {isReceiptModalOpen && receiptData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
          {/* Overlay */}
          <div
            className="absolute inset-0"
            onClick={() => setIsReceiptModalOpen(false)}
          />

          {/* Modal */}
          <div
            className={`relative w-full max-w-2xl overflow-hidden rounded-2xl border shadow-2xl ${
              isDarkMode
                ? "border-[#30363D] bg-[#161B22]"
                : "border-gray-200 bg-white"
            }`}
          >
            {/* ================= HEADER ================= */}
            <div
              className={`flex items-center justify-between gap-4 border-b px-5 py-3.5 ${
                isDarkMode ? "border-[#30363D]" : "border-gray-200"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-50 text-blue-600"
                  }`}
                >
                  <i className="fas fa-receipt text-xs" />
                </div>

                <div>
                  <h3
                    className={`text-sm font-semibold ${
                      isDarkMode ? "text-gray-100" : "text-gray-900"
                    }`}
                  >
                    Détail de paiement
                  </h3>

                  <p className="mt-0.5 text-[9px] text-gray-500">
                    Informations relatives à cette transaction
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4">
                {/* Date */}
                <div className="hidden text-right sm:block">
                  <p
                    className={`text-[10px] font-medium ${
                      isDarkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {moment(receiptData.date).format("DD/MM/YYYY HH:MM")}
                  </p>

                  <p className="mt-0.5 text-[9px] text-gray-500">
                    Année scolaire {receiptData?.annee_scolaire_designation}
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => setIsReceiptModalOpen(false)}
                  className={`flex h-8 w-8 items-center justify-center rounded-lg border transition ${
                    isDarkMode
                      ? "border-[#30363D] text-gray-400 hover:bg-[#21262D] hover:text-white"
                      : "border-gray-200 text-gray-500 hover:bg-gray-100"
                  }`}
                >
                  <i className="fas fa-times text-[10px]" />
                </button>
              </div>
            </div>

            {/* ================= CONTENT ================= */}
            <div className="space-y-3 p-4 sm:px-5">
              {/* Date mobile */}
              <div
                className={`flex items-center justify-between rounded-lg border px-3 py-2 sm:hidden ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#0D1117]"
                    : "border-gray-200 bg-gray-50"
                }`}
              >
                <div className="flex items-center gap-2">
                  <i className="far fa-calendar-alt text-[10px] text-gray-500" />

                  <span
                    className={`text-[10px] ${
                      isDarkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    {moment(receiptData.date).format("DD/MM/YYYY HH:MM")}
                  </span>
                </div>

                <span className="text-[9px] text-gray-500">
                  {receiptData?.annee_scolaire_designation}
                </span>
              </div>

              {/* ================= ÉLÈVE / CLASSE ================= */}
              <div
                className={`grid grid-cols-1 overflow-hidden rounded-xl border sm:grid-cols-[1.5fr_1fr] ${
                  isDarkMode ? "border-[#30363D]" : "border-gray-200"
                }`}
              >
                {/* Élève */}
                <div
                  className={`flex items-center gap-3 px-4 py-3 sm:border-r ${
                    isDarkMode ? "border-[#30363D]" : "border-gray-200"
                  }`}
                >
                  <div
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-blue-500/10 text-blue-400"
                        : "bg-blue-50 text-blue-600"
                    }`}
                  >
                    <i className="fas fa-user-graduate text-[10px]" />
                  </div>

                  <div className="min-w-0">
                    <p className="text-[9px] font-medium uppercase tracking-wide text-gray-500">
                      Élève
                    </p>

                    <p
                      className={`mt-0.5 truncate text-xs font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      {`${capitalizeFirstLetter(
                        dataStudent.nom,
                      )} ${capitalizeFirstLetter(
                        dataStudent.postnom,
                      )} ${capitalizeFirstLetter(dataStudent.prenom)}`}
                    </p>
                  </div>
                </div>

                {/* Classe */}
                <div
                  className={`flex items-center gap-3 border-t px-4 py-3 sm:border-t-0 ${
                    isDarkMode ? "border-[#30363D]" : "border-gray-200"
                  }`}
                >
                  <div
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-[#21262D] text-gray-400"
                        : "bg-gray-100 text-gray-500"
                    }`}
                  >
                    <i className="fas fa-school text-[10px]" />
                  </div>

                  <div>
                    <p className="text-[9px] font-medium uppercase tracking-wide text-gray-500">
                      Classe
                    </p>

                    <p
                      className={`mt-0.5 text-xs font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      {currentClasseDesignation}
                    </p>
                  </div>
                </div>
              </div>

              {/* ================= TRANSACTION ================= */}
              <div
                className={`overflow-hidden rounded-xl border ${
                  isDarkMode ? "border-[#30363D]" : "border-gray-200"
                }`}
              >
                <table className="w-full">
                  <thead>
                    <tr className={isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"}>
                      <th className="px-4 py-2.5 text-left text-[9px] font-semibold uppercase tracking-wide text-gray-500">
                        Description
                      </th>

                      <th className="px-4 py-2.5 text-right text-[9px] font-semibold uppercase tracking-wide text-gray-500">
                        Montant ($)
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      className={`border-t ${
                        isDarkMode ? "border-[#30363D]" : "border-gray-200"
                      }`}
                    >
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2.5">
                          <div
                            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${
                              isDarkMode
                                ? "bg-blue-500/10 text-blue-400"
                                : "bg-blue-50 text-blue-600"
                            }`}
                          >
                            <i className="fas fa-file-invoice-dollar text-[9px]" />
                          </div>

                          <span
                            className={`text-xs font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {receiptData.type === "1"
                              ? "Frais de scolarité"
                              : receiptData.type === "2"
                                ? "Frais d'examen"
                                : receiptData.type === "3"
                                  ? "Frais d'inscription"
                                  : "Autre paiement"}
                          </span>
                        </div>
                      </td>

                      <td
                        className={`px-4 py-3 text-right text-sm font-semibold ${
                          isDarkMode ? "text-gray-100" : "text-gray-900"
                        }`}
                      >
                        {receiptData.amount}
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr
                      className={`border-t ${
                        isDarkMode
                          ? "border-[#30363D] bg-[#0D1117]/70"
                          : "border-gray-200 bg-gray-50"
                      }`}
                    >
                      <td
                        className={`px-4 py-2.5 text-xs font-semibold ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Total
                      </td>

                      <td className="px-4 py-2.5 text-right">
                        <span
                          className={`text-sm font-bold ${
                            isDarkMode ? "text-emerald-400" : "text-emerald-600"
                          }`}
                        >
                          {receiptData.amount} $
                        </span>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* ================= MODE + STATUT ================= */}
              <div
                className={`grid grid-cols-2 overflow-hidden rounded-xl border ${
                  isDarkMode ? "border-[#30363D]" : "border-gray-200"
                }`}
              >
                {/* Mode */}
                <div
                  className={`flex items-center gap-3 border-r px-4 py-3 ${
                    isDarkMode ? "border-[#30363D]" : "border-gray-200"
                  }`}
                >
                  <div
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-[#21262D] text-gray-400"
                        : "bg-gray-100 text-gray-500"
                    }`}
                  >
                    <i className="fas fa-money-bill-wave text-[9px]" />
                  </div>

                  <div>
                    <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                      Mode de paiement
                    </p>

                    <p
                      className={`mt-0.5 text-[11px] font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      {"Espèce"}
                    </p>
                  </div>
                </div>

                {/* Statut */}
                <div className="flex items-center gap-3 px-4 py-3">
                  <div
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${
                      receiptData.status === "1"
                        ? isDarkMode
                          ? "bg-emerald-500/10 text-emerald-400"
                          : "bg-emerald-50 text-emerald-600"
                        : isDarkMode
                          ? "bg-red-500/10 text-red-400"
                          : "bg-red-50 text-red-600"
                    }`}
                  >
                    <i
                      className={`fas ${
                        receiptData.status === "1" ? "fa-check" : "fa-times"
                      } text-[9px]`}
                    />
                  </div>

                  <div>
                    <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                      Statut
                    </p>

                    <span
                      className={`mt-0.5 inline-flex items-center gap-1.5 text-[11px] font-semibold ${
                        receiptData.status === "1"
                          ? "text-emerald-500"
                          : "text-red-500"
                      }`}
                    >
                      <span
                        className={`h-1.5 w-1.5 rounded-full ${
                          receiptData.status === "1"
                            ? "bg-emerald-500"
                            : "bg-red-500"
                        }`}
                      />

                      {receiptData.status === "1" ? "Payé" : "Annulé"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= FOOTER ================= */}
            <div
              className={`flex justify-end border-t px-5 py-3 ${
                isDarkMode
                  ? "border-[#30363D] bg-[#0D1117]/40"
                  : "border-gray-200 bg-gray-50/70"
              }`}
            >
              <button
                onClick={() => setIsReceiptModalOpen(false)}
                className={`flex h-9 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                }`}
              >
                <i className="fas fa-times text-[9px]" />
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Annuler Paiement Confirmation Modal */}
      {showCancelModal && currentPaiementId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
          <div
            className={`relative w-full max-w-md overflow-hidden rounded-2xl border shadow-2xl ${
              isDarkMode
                ? "border-[#30363D] bg-[#161B22]"
                : "border-gray-200 bg-white"
            }`}
          >
            {/* ================= HEADER ================= */}
            <div
              className={`flex items-center justify-between gap-4 border-b px-5 py-3.5 ${
                isDarkMode ? "border-[#30363D]" : "border-gray-200"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-red-500/10 text-red-400"
                      : "bg-red-50 text-red-600"
                  }`}
                >
                  <i className="fas fa-exclamation-triangle text-xs" />
                </div>

                <div>
                  <h3
                    className={`text-sm font-semibold ${
                      isDarkMode ? "text-gray-100" : "text-gray-900"
                    }`}
                  >
                    Annuler le paiement
                  </h3>

                  <p className="mt-0.5 text-[9px] text-gray-500">
                    Confirmation d'une opération irréversible
                  </p>
                </div>
              </div>

              {/* Fermer */}
              <button
                type="button"
                disabled={mutationAnnulerPayment.isPending}
                onClick={() => {
                  setCurrentPaiementId(null);
                  setShowCancelModal(false);
                }}
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border transition-colors ${
                  isDarkMode
                    ? "border-[#30363D] text-gray-400 hover:bg-[#21262D] hover:text-white"
                    : "border-gray-200 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                } ${
                  mutationAnnulerPayment.isPending
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
                title="Fermer"
              >
                <i className="fas fa-times text-[10px]" />
              </button>
            </div>

            {/* ================= CONTENT ================= */}
            <div className="p-5">
              {/* Alerte */}
              <div
                className={`flex items-start gap-3 rounded-xl border p-4 ${
                  isDarkMode
                    ? "border-red-500/20 bg-red-500/[0.05]"
                    : "border-red-100 bg-red-50/60"
                }`}
              >
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-red-500/10 text-red-400"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  <i className="fas fa-exclamation-triangle text-xs" />
                </div>

                <div className="min-w-0">
                  <p
                    className={`text-xs font-semibold ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                    }`}
                  >
                    Confirmer l'annulation
                  </p>

                  <p
                    className={`mt-1.5 text-[11px] leading-relaxed ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Êtes-vous sûr de vouloir annuler ce paiement de{" "}
                    <span
                      className={`font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      {paymentForm.amount} {" $"}
                    </span>{" "}
                    ?
                  </p>
                </div>
              </div>

              {/* Montant */}
              <div
                className={`mt-3 flex items-center justify-between rounded-xl border px-4 py-3 ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#0D1117]"
                    : "border-gray-200 bg-gray-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-[#21262D] text-gray-400"
                        : "bg-white text-gray-500"
                    }`}
                  >
                    <i className="fas fa-money-bill-wave text-[10px]" />
                  </div>

                  <div>
                    <p className="text-[9px] font-medium uppercase tracking-wide text-gray-500">
                      Montant du paiement
                    </p>

                    <p
                      className={`mt-0.5 text-sm font-bold ${
                        isDarkMode ? "text-gray-100" : "text-gray-900"
                      }`}
                    >
                      {paymentForm.amount} $
                    </p>
                  </div>
                </div>

                <div
                  className={`flex h-7 items-center gap-1.5 rounded-full px-2.5 text-[9px] font-semibold ${
                    isDarkMode
                      ? "bg-red-500/10 text-red-400"
                      : "bg-red-50 text-red-600"
                  }`}
                >
                  <i className="fas fa-ban text-[8px]" />
                  Annulation
                </div>
              </div>

              {/* Warning */}
              <div className="mt-3 flex items-center gap-2 px-1">
                <i className="fas fa-info-circle text-[9px] text-red-500" />

                <p
                  className={`text-[9px] ${
                    isDarkMode ? "text-gray-500" : "text-gray-500"
                  }`}
                >
                  Cette action est irréversible et ne pourra pas être annulée.
                </p>
              </div>
            </div>

            {/* ================= FOOTER ================= */}
            <div
              className={`flex flex-col-reverse gap-2 border-t px-5 py-3.5 sm:flex-row sm:items-center sm:justify-end ${
                isDarkMode
                  ? "border-[#30363D] bg-[#0D1117]/40"
                  : "border-gray-200 bg-gray-50/70"
              }`}
            >
              {/* ANNULER */}
              <button
                disabled={mutationAnnulerPayment.isPending}
                onClick={() => {
                  setCurrentPaiementId(null);
                  setShowCancelModal(false);
                }}
                className={`flex h-10 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition-colors ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                } ${
                  mutationAnnulerPayment.isPending
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              >
                <i className="fas fa-times text-[9px]" />
                Annuler
              </button>

              {/* CONFIRMER */}
              <button
                onClick={() => {
                  setShowCancelModal(false);

                  setPendingPaiementAction("cancel");
                }}
                className="flex h-10 items-center justify-center gap-2 rounded-lg bg-red-600 px-5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-red-700"
              >
                <i className="fas fa-ban text-[9px]" />
                Confirmer l'annulation
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bottom Action Bar */}
      {(studentAttendanceLoading ||
        activeSchoolYearLoading ||
        paiementDataLoading ||
        motifPaiementLoading ||
        montantPerClasseLoading) ??
        null}

      {/* ===== MODAL DE MOT DE PASSE ===== */}
      {pendingPaiementAction && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
          <div
            className={`relative w-full max-w-md overflow-hidden rounded-2xl border shadow-2xl ${
              isDarkMode
                ? "border-[#30363D] bg-[#161B22]"
                : "border-gray-200 bg-white"
            }`}
          >
            {/* ================= HEADER ================= */}
            <div
              className={`flex items-start gap-3 border-b px-5 py-4 ${
                isDarkMode ? "border-[#30363D]" : "border-gray-200"
              }`}
            >
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                  isDarkMode
                    ? "bg-blue-500/10 text-blue-400"
                    : "bg-blue-50 text-blue-600"
                }`}
              >
                <i className="fas fa-shield-alt text-sm" />
              </div>

              <div className="min-w-0">
                <h3
                  className={`text-sm font-semibold sm:text-base ${
                    isDarkMode ? "text-gray-100" : "text-gray-900"
                  }`}
                >
                  Confirmation requise
                </h3>

                <p
                  className={`mt-1 text-[10px] leading-relaxed sm:text-[11px] ${
                    isDarkMode ? "text-gray-500" : "text-gray-500"
                  }`}
                >
                  Cette opération nécessite une vérification de votre identité.
                </p>
              </div>
            </div>

            {/* ================= CONTENT ================= */}
            <div className="p-5 sm:p-6">
              {/* Information */}
              <div
                className={`mb-5 flex items-start gap-3 rounded-xl border p-3.5 ${
                  isDarkMode
                    ? "border-blue-500/20 bg-blue-500/[0.05]"
                    : "border-blue-100 bg-blue-50/60"
                }`}
              >
                <div
                  className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-100 text-blue-600"
                  }`}
                >
                  <i className="fas fa-info text-[10px]" />
                </div>

                <div>
                  <p
                    className={`text-[11px] font-semibold ${
                      isDarkMode ? "text-blue-300" : "text-blue-700"
                    }`}
                  >
                    Vérification de sécurité
                  </p>

                  <p
                    className={`mt-1 text-[10px] leading-relaxed ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    }`}
                  >
                    Veuillez entrer votre mot de passe pour confirmer valider
                    l'opération.
                  </p>
                </div>
              </div>

              {/* Password */}
              <div>
                <div className="mb-2 flex items-center gap-2">
                  <div
                    className={`flex h-7 w-7 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-[#21262D] text-gray-400"
                        : "bg-gray-100 text-gray-500"
                    }`}
                  >
                    <i className="fas fa-key text-[10px]" />
                  </div>

                  <label
                    className={`text-[11px] font-semibold ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Mot de passe
                  </label>

                  <span className="text-red-500">*</span>
                </div>

                <div
                  className={`relative overflow-hidden rounded-xl border transition-colors focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/10 ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#0D1117]"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <div
                    className={`pointer-events-none absolute inset-y-0 left-0 flex w-11 items-center justify-center border-r ${
                      isDarkMode
                        ? "border-[#30363D] text-gray-500"
                        : "border-gray-200 text-gray-400"
                    }`}
                  >
                    <i className="fas fa-lock text-[10px]" />
                  </div>

                  <input
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`h-11 w-full bg-transparent pl-14 pr-4 text-xs outline-none ${
                      isDarkMode
                        ? "text-gray-200 placeholder:text-gray-600"
                        : "text-gray-700 placeholder:text-gray-400"
                    }`}
                    placeholder="Entrez votre mot de passe"
                  />
                </div>

                <div
                  className={`mt-2 flex items-center gap-1.5 text-[9px] ${
                    isDarkMode ? "text-gray-600" : "text-gray-400"
                  }`}
                >
                  <i className="fas fa-lock text-[8px]" />
                  <span>
                    Votre mot de passe est requis pour autoriser cette
                    opération.
                  </span>
                </div>
              </div>
            </div>

            {/* ================= FOOTER ================= */}
            <div
              className={`flex flex-col-reverse gap-2 border-t px-5 py-4 sm:flex-row sm:items-center sm:justify-end ${
                isDarkMode
                  ? "border-[#30363D] bg-[#0D1117]/40"
                  : "border-gray-200 bg-gray-50/70"
              }`}
            >
              {/* ANNULER */}
              <button
                disabled={
                  mutationLogin.isPending ||
                  mutationAnnulerPayment.isPending ||
                  mutationCreatePayment.isPending
                }
                onClick={() => {
                  setPendingPaiementAction(null);
                  setPassword("");
                  setPaymentForm({
                    date: "",
                    amount: "",
                    type: "",
                    method: "Espèce",
                    status: 1,
                    isEditing: false,
                    editingId: null,
                  });
                }}
                className={`flex h-10 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition-colors ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                }${
                  (mutationLogin.isPending ||
                    mutationCreatePayment.isPending ||
                    mutationUpdatePayment.isPending) &&
                  "cursor-not-allowed opacity-50"
                }`}
              >
                <i className="fas fa-times text-[9px]" />
                Annuler
              </button>

              {/* CONFIRMER */}
              <button
                disabled={
                  mutationLogin.isPending ||
                  mutationAnnulerPayment.isPending ||
                  mutationCreatePayment.isPending
                }
                onClick={() => {
                  handleConfirmPassword();
                }}
                className={`flex h-10 min-w-[120px] items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-blue-700 ${
                  (mutationLogin.isPending ||
                    mutationAnnulerPayment.isPending ||
                    mutationCreatePayment.isPending) &&
                  "cursor-not-allowed opacity-60"
                }`}
              >
                {mutationLogin.isPending ||
                mutationCreatePayment.isPending ||
                mutationUpdatePayment.isPending ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin text-[10px]" />
                    <span>Traitement en cours...</span>
                  </>
                ) : (
                  <>
                    <i className="fas fa-check text-[10px]" />
                    <span>Confirmer</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* {pendingPaiementAction && (
        <div className="fixed inset-0 z-[60] overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-md rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } p-6`}
          >
            <h3
              className={`text-lg font-medium mb-4 ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Confirmation requise
            </h3>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              } mb-4`}
            >
              Veuillez entrer votre mot de passe pour confirmer valider
              l'opération.
            </p>

            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full px-3 py-2 rounded-md border ${
                isDarkMode
                  ? "bg-[#0D1117] border-gray-700 text-white"
                  : "bg-white border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4`}
              placeholder="Entrez votre mot de passe"
            />

            <div className="flex justify-end space-x-3">
              <button
                disabled={
                  mutationLogin.isPending ||
                  mutationAnnulerPayment.isPending ||
                  mutationCreatePayment.isPending
                }
                onClick={() => {
                  setPendingPaiementAction(null);
                  setPassword("");
                  setPaymentForm({
                    date: "",
                    amount: "",
                    type: "",
                    method: "Espèce",
                    status: 1,
                    isEditing: false,
                    editingId: null,
                  });
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  (mutationLogin.isPending ||
                    mutationCreatePayment.isPending ||
                    mutationUpdatePayment.isPending) &&
                  "cursor-not-allowed"
                }`}
              >
                Annuler
              </button>
              <button
                disabled={
                  mutationLogin.isPending ||
                  mutationAnnulerPayment.isPending ||
                  mutationCreatePayment.isPending
                }
                onClick={() => {
                  handleConfirmPassword();
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap ${
                  (mutationLogin.isPending ||
                    mutationAnnulerPayment.isPending ||
                    mutationCreatePayment.isPending) &&
                  "cursor-not-allowed"
                }`}
              >
                {mutationLogin.isPending ||
                mutationCreatePayment.isPending ||
                mutationUpdatePayment.isPending
                  ? "Traitement en cours..."
                  : "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      )} */}

      <MyLoader
        isLoading={
          mutationAnnulerPayment.isPending || mutationCreatePayment.isPending
        }
        message={
          mutationAnnulerPayment.isPending
            ? "Annulation en cours..."
            : mutationUpdatePayment.isPending
              ? "Mise à jour en cours..."
              : mutationCreatePayment.isPending
                ? "Paiement en cours..."
                : ""
        }
      />
      <MyLoader
        isLoading={mutationLogin.isPending}
        message="Vérification en cours..."
      />

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg z-[60] text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};
export default SingleStudent;
